import React, { useState, useEffect, useRef, useMemo } from "react";
import {
  Col,
  FormGroup,
  Input,
  Row,
  ModalFooter,
  ModalBody,
  ModalHeader,
  Modal,
  Container,
} from "reactstrap";
import { Image, Btn } from "../../AbstractElements";
import DataTable from "react-data-table-component";
import Form from "react-bootstrap/Form";
import {
  Button,
  OverlayTrigger,
  Popover,
  Spinner,
  Table,
} from "react-bootstrap";
import { AiOutlinePlus } from "react-icons/ai";
import ReactSelect from "react-select";
import makeAnimated from "react-select/animated";
import "./dashboardpos.css";
import axios from "../../axios/axios";
import Swal from "sweetalert2";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { FiTrash } from "react-icons/fi";
import { FaPrint, FaSave, FaWhatsapp } from "react-icons/fa";
import { MdContactPhone, MdCreateNewFolder, MdDrafts } from "react-icons/md";
import { FaEdit } from "react-icons/fa";
import { RiDeleteBin7Fill } from "react-icons/ri";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./dashboardpos.css";

// Import Redux actions
import {
  addDraftItem,
  removeDraftItem,
  clearAllDrafts
} from "../../utils/draftSlice";
import { toggleModal, closeModal } from "../../utils/modalSlice";

// Import POS Redux actions
import {
  setCart,
  addToCart,
  updateCartItem,
  removeFromCart,
  clearCart as clearCartAction,
  setSelectedUnits,
  updateSelectedUnit,
  setContactDetails,
  setAddressDetails,
  setAddCustomerDetails,
  setSelectedCompany,
  setSelectedBranch,
  setSearchQuery,
  setSearchBarcode,
  setShowBillingModal,
  setShowShippingModal,
  setIsInvoiceSaved,
  setInvoiceDetails,
  setSelectedCategory,
  setSelectedMaincategory,
  setCategorySearchQuery,
  setSubTArray,
  setShowQtyRed,
  setSaveBtn,
  setPrintBtn,
  setWhatsappBtn,
  resetForNewInvoice,
  resetPosState
} from "../../utils/posSlice";

import moment from "moment";
import { IoIosAddCircle } from "react-icons/io";
import { useReactToPrint } from "react-to-print";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import AttributeMasterModal from "./AttributeMasterModal";

const Dashboardpos = () => {
  const baseurl = useSelector((store) => store.baseUrl);
  const AUTHORIZE_KEY = "c34FxCQy4DCGCHA9zlTgqTsywZJSW8hy";

  // Get POS state from Redux
  const posState = useSelector((state) => state.pos);
  const {
    cart,
    selectedUnits,
    contactId: contact_id,
    contactName: contact_name,
    contactNumber: contact_number,
    billingAddressId: Billingaddress_id,
    shippingAddressId: Shippingaddress_id,
    sameAsBilling,
    addCustomerDetails,
    selectedCompany,
    selectedBranch,
    searchQuery,
    searchBarcode,
    showBillingModal,
    showShippingModal,
    isInvoiceSaved,
    invoiceNo: Invoice_no,
    invoiceFullNo: Invoice_fullno,
    selectedCategory,
    selectedMaincategory,
    categorySearchQuery,
    subTArray,
    showQtyRed,
    saveBtn: Savebtn,
    printBtn: Printbtn,
    whatsappBtn: whatsappbtn,
  } = posState;

  // Get drafts from Redux
  const { draftItems: drafts, count: draftsCount } = useSelector((state) => state.drafts);
  const { isOpen } = useSelector((store) => store.modaldraft);

  const [firstAPICallMade, setFirstAPICallMade] = useState(false);
  const dispatch = useDispatch();

  // navbar
  const [showMore, setShowMore] = useState(false);

  const handleMoreClick = () => {
    setShowMore(!showMore);
    dispatch(setSelectedMaincategory("More"));
  };

  const {
    register,
    setValue,
    handleSubmit,
    reset,
  } = useForm();

  // attribute
  const [showattrmodal, setShowattrmodal] = useState(false);
  const [productImage, setProductImage] = useState("");
  const [product_selectid, setProductselectid] = useState("");
  const [selected_prod_index, setSelectedprodindex] = useState(null);
  const [attr_array, setAttrarray] = useState([]);
  const [json, setJson] = useState({});
  const [json_name, setJsonName] = useState({});

  // 2. STATE — replace attrModalMode with a dedicated modal open flag
  //    (keep showattrmodal ONLY for the pricelist modal)
  const [showAttrMasterModal, setShowAttrMasterModal] = useState(false);
  const [attrMasterPre, setAttrMasterPre] = useState([]); // DATA.attr_master_pre
  const [attrMasterArr, setAttrMasterArr] = useState([]); // attribute_arr (Type == 3)

  // new pricelistwise
  const [attr_label, setAttrlabel] = useState([]);
  const [pricelist_array, setPricelistaarray] = useState([]);

  const [AttrProductname, setAttrProductname] = useState("");
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [branchError, setBranchError] = useState(false);

  // Wire this to your real source (localStorage / API / redux). Hardcoded for now.
  const userdetails = JSON.parse(localStorage.getItem("userdetails")) || {};
  const autoadjustflg = userdetails?.inv_roundoff == "Y";
  // config flag — wire to your real config source
  const ecommerce_on = userdetails?.ecommerce_module === true;
  const withoutstockbypass = userdetails?.withoutstockbypass == "1"; // ✅ NEW

  const [adjustmentType, setAdjustmentType] = useState("deduct"); // "add" | "deduct"
  const [adjustmentValue, setAdjustmentValue] = useState("");

  const image_url_logo = localStorage.getItem("company_logo_pos");

  // 3. TOGGLE for the new modal (mirrors toggleattributemodal)
  const toggleAttrMasterModal = () => {
    setShowAttrMasterModal(false);
    setProductselectid("");
    setSelectedProduct(null);
    setProductImage("");
    setAttrMasterPre([]);
    setAttrMasterArr([]);
  };

  const generatePDF = async () => {
    window.html2canvas = html2canvas;
    let originalStyles = {};

    try {
      const element = document.querySelector("#rep1");
      originalStyles = {
        position: element.style.position,
        left: element.style.left,
        top: element.style.top,
        visibility: element.style.visibility,
      };

      element.style.position = "absolute";
      element.style.left = "-9999px";
      element.style.visibility = "visible";

      await new Promise((resolve) => setTimeout(resolve, 150));

      const pdf = new jsPDF("p", "mm", "a4");
      const canvas = await html2canvas(element, {
        scale: 2,
        logging: false,
        useCORS: true,
        allowTaint: true,
        width: element.scrollWidth,
        height: element.scrollHeight,
        windowWidth: element.scrollWidth,
        windowHeight: element.scrollHeight,
      });

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const imgWidth = pdfWidth - 10;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      pdf.addImage(canvas, "PNG", 5, 5, imgWidth, imgHeight, undefined, "FAST");

      const blobPDF = new Blob([pdf.output("blob")], {
        type: "application/pdf",
      });

      const customerName = contact_name || defaultPosContact?.name || "Customer";
      const message = `Hi ${customerName}, Attached is your invoice. Let me know if you need anything else.`;

      const formData = new FormData();
      formData.append("image", blobPDF);
      formData.append("invoice_id", Invoice_no || "");
      formData.append("contact_id", contact_id || defaultPosContact?.id || "");
      formData.append("countrycode", 91);
      formData.append(
        "mobileno",
        selectedContact?.mobile || defaultPosContact?.mobile || ""
      );
      formData.append("wp_clientmsg", message);
      formData.append("contactType", 1);
      formData.append("AUTHORIZEKEY", AUTHORIZE_KEY);
      formData.append("PHPTOKEN", localStorage.getItem("id_token") || "");

      // ─── Pre-flight validations ──────────────────────────────────────
      const missingFields = [];
      if (!formData.get("invoice_id")) missingFields.push("Invoice No");
      if (!formData.get("contact_id")) missingFields.push("Contact");
      if (!formData.get("mobileno")) missingFields.push("Mobile Number");

      if (missingFields.length > 0) {
        setShowgeneratetext(false);
        dispatch(setWhatsappBtn(false));
        toast.error(
          `Cannot send WhatsApp: Missing ${missingFields.join(", ")}.`,
          { position: "top-right", autoClose: 5000 }
        );
        return;
      }

      // ─── API call ────────────────────────────────────────────────────
      const response = await fetch(
        `${baseurl}/expo_access_api/invoicePdfsendfdtowhatsapp/`,
        {
          method: "POST",
          body: formData,
        }
      );

      // Handle HTTP errors (network down, 500, 404, etc.)
      if (!response.ok) {
        let errorMsg = `Server returned ${response.status} (${response.statusText})`;
        try {
          const errorData = await response.json();
          if (errorData?.[0]?.MSG) errorMsg = errorData[0].MSG;
        } catch {
          // response body is not JSON — keep generic message
        }
        throw new Error(errorMsg);
      }

      // ─── Parse JSON response ───────────────────────────────────────
      let apiResponse;
      try {
        apiResponse = await response.json();
      } catch {
        throw new Error("Invalid response from server. Please try again.");
      }

      // ─── Handle API-level errors ───────────────────────────────────
      const apiStatus = apiResponse?.[0]?.STATUS;
      const apiMessage = apiResponse?.[0]?.MSG || "Unknown error";

      if (apiStatus === "ERROR") {
        throw new Error(apiMessage);
      }

      if (apiStatus !== "SUCCESS") {
        throw new Error(apiMessage);
      }

      // ─── Success ───────────────────────────────────────────────────
      setShowgeneratetext(false);
      dispatch(setWhatsappBtn(false));
      toast.success("Invoice sent successfully!", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } catch (error) {
      console.error("Error while generating or sending PDF:", error);
      setShowgeneratetext(false);
      dispatch(setWhatsappBtn(false));

      const userMsg =
        error?.message || "Failed to send invoice via WhatsApp. Please try again.";
      toast.error(userMsg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } finally {
      const element = document.querySelector("#rep1");
      if (element) {
        element.style.position = originalStyles.position || "";
        element.style.left = originalStyles.left || "";
        element.style.top = originalStyles.top || "";
        element.style.visibility = originalStyles.visibility || "";
      }
    }
  };

  const visibleAttrKeys = useMemo(() => {
    if (!attr_label || Object.keys(attr_label).length === 0) return [];
    return Object.keys(attr_label).filter((key) => {
      const attrId = attr_label[key]?.ID;
      return pricelist_array.some((row) =>
        row.attr_arr?.some(
          (a) =>
            String(a.ID) === String(attrId) &&
            a.Value != null &&
            String(a.Value).trim() !== ""
        )
      );
    });
  }, [attr_label, pricelist_array]);

  useEffect(() => {
    const delay = 1000;
    let timeoutId;

    const delayedAPICall = async () => {
      try {
        setFirstAPICallMade(true);
        await getProductByBarcode(searchBarcode);
      } catch (error) {
        console.error("Error in getProductByBarcode API:", error);
      }
    };

    const handleChange = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(delayedAPICall, delay);
    };

    if (searchBarcode) {
      handleChange();
    }

    return () => clearTimeout(timeoutId);
  }, [searchBarcode]);

  // new json format
  const Saveattributejson = (index) => {
    if (!product_selectid || index < 0 || index >= pricelist_array.length)
      return;

    const selectedEntry = pricelist_array[index];

    if (selectedEntry) {
      const selectedprice = selectedEntry.price;
      const newSelectedJson = {
        [product_selectid]: combinedArrayToJSON(
          attr_label,
          selectedEntry.attr_arr
        ),
      };
      const newSelectedJsonName = {
        [product_selectid]: combinedArrayToJSONName(
          attr_label,
          selectedEntry.attr_arr
        ),
      };

      setJson(newSelectedJson);
      setJsonName(newSelectedJsonName);
      setCartinfo("Data found");
      getBranchWiseProductCurrentStock(
        selectedProduct,
        newSelectedJson,
        newSelectedJsonName,
        selectedprice
      );
    } else {
      console.error(`Product with ID ${product_selectid} not found.`);
    }
  };

  const combinedArrayToJSON = (attr_label, attr_arr) => {
    return Object.values(attr_label).reduce((result, attr, index) => {
      const value_id = String(attr.ID);
      const value = attr_arr[index]?.valueID;
      result[value_id] = value;
      return result;
    }, {});
  };

  const combinedArrayToJSONName = (attr_label, attr_arr) => {
    return Object.values(attr_label).reduce((result, attr, index) => {
      const label = attr.Label;
      const value = attr_arr[index]?.Value;
      result[label] = value;
      return result;
    }, {});
  };

  async function getProductPriceList(item, id, Productname, index) {
    try {
      if (id !== "") {
        const res = await axios.post(
          baseurl + "/expo_access_api/getProductPriceList/",
          {
            AUTHORIZEKEY: AUTHORIZE_KEY,
            product_id: id,
          }
        );

        if (res && res.data && res.data[0].STATUS == "SUCCESS") {
          const pricelistArray = res.data[0].DATA.pricelist_array;

          if (Array.isArray(pricelistArray) && pricelistArray.length != 0) {
            setAttrlabel(res.data[0].DATA.attrlabel_arr);
            setPricelistaarray(pricelistArray);
            setProductselectid(id);
            setAttrProductname(Productname);
            setSelectedprodindex(index);
            setShowattrmodal(!showattrmodal);
            setSelectedProduct(item);
            setProductImage(item.original_photo_path);
          } else {
            setCartloading(true);
            setCartinfo("Data found");
            setAttrlabel([]);
            setPricelistaarray([]);
            setProductselectid(id);
            setSelectedProduct(item);
            getBranchWiseProductCurrentStock(item, "", "", "");
          }
        } else {
          setCartloading(true);
          setCartinfo("Data found");
          setAttrlabel([]);
          setPricelistaarray([]);
          setProductselectid(id);
          setSelectedProduct(item);
          getBranchWiseProductCurrentStock(item, "", "", "");
        }
      }
    } catch (error) {
      console.error("Error while fetching product attributes:", error);
    }
  }

  // 4. FETCH — opens the separate modal when rows exist
  async function getAttributeMasterPOS(item, id, Productname, index) {
    try {
      if (id === "") return;
      const res = await axios.post(
        baseurl + "/texttilebotapi/getAttributeMaster/",
        {
          AUTHORIZEKEY: AUTHORIZE_KEY,
          PHPTOKEN: localStorage.getItem("id_token"),
          search_by: 1,
          product_id: id,
        }
      );

      if (res?.data?.[0]?.STATUS == "SUCCESS") {
        const data = res.data[0].DATA;
        const preRows = data?.attr_master_pre || [];

        if (Array.isArray(preRows) && preRows.length > 0) {
          setAttrMasterPre(preRows);
          setAttrMasterArr(
            (data?.attribute_arr || []).filter((a) => a.Type == 3)
          );
          setProductselectid(id);
          setAttrProductname(data?.product_name || Productname);
          setSelectedprodindex(index);
          setSelectedProduct(item);
          setProductImage(item.original_photo_path);
          setShowAttrMasterModal(true); // ✅ separate modal
          return;
        }
      }

      // No attribute rows → same fallback as empty-pricelist case
      setCartloading(true);
      setCartinfo("Data found");
      setAttrMasterPre([]);
      setAttrMasterArr([]);
      setProductselectid(id);
      setSelectedProduct(item);
      getBranchWiseProductCurrentStock(item, "", "", "");
    } catch (error) {
      console.error("Error while fetching attribute master:", error);
    }
  }

  // 5. ROUTING — branch inside Openatrributemodal
  const Openatrributemodal = (item, id, Productname, index) => {
    if (!selectedBranch) {
      setBranchError(true);
      toast.error("Please select a branch first.", {
        position: "top-right",
        autoClose: 3000,
      });
      return;
    }
    setBranchError(false);

    if (ecommerce_on) {
      getAttributeMasterPOS(item, id, Productname, index); // ✅ new modal
    } else {
      getProductPriceList(item, id, Productname, index); // existing pricelist modal
    }
  };

  // ─── 1. Variant key helper (put near calculateSubT) ─────────────────
  // Prefer sku_code (already unique per combination, e.g. "13_1").
  // Fallback: deterministic key from the attribute json (sorted so
  // {13:"1",14:"2"} and {14:"2",13:"1"} produce the same key).
  const buildVariantKey = (productId, skuCode, attributeJson) => {
    if (skuCode) return `${productId}::${skuCode}`;

    const attrs = attributeJson?.[productId] || attributeJson || {};
    const attrPart = Object.keys(attrs)
      .sort()
      .map((k) => `${k}_${attrs[k]}`)
      .join("_");

    return attrPart ? `${productId}::${attrPart}` : `${productId}::default`;
  };

  // ─── 2. Modal callback — pass sku_code through ──────────────────────
  const handleAttrMasterRowSelect = (row, json, jsonName, selectedprice) => {
    if (!product_selectid) return;

    const newSelectedJson = { [product_selectid]: json };
    const newSelectedJsonName = { [product_selectid]: jsonName };

    setJson(newSelectedJson);
    setJsonName(newSelectedJsonName);
    setCartinfo("Data found");
    setShowAttrMasterModal(false);

    getBranchWiseProductCurrentStock(
      selectedProduct,
      newSelectedJson,
      newSelectedJsonName,
      selectedprice,
      row.sku_code // ✅ NEW 5th arg
    );
  };

  const toggleattributemodal = () => {
    setShowattrmodal(!showattrmodal);
    setProductImage("");
  };

  // const getBranchWiseProductCurrentStock = async (
  //   selectedProduct,
  //   selectedJson,
  //   selectedJson_Name,
  //   selectedprice
  // ) => {
  //   try {
  //     const response = await axios.post(
  //       "/expo_access_api/getBranchWiseProductCurrentStock/",
  //       {
  //         AUTHORIZEKEY: AUTHORIZE_KEY,
  //         product_id: selectedProduct?.product_id,
  //         // Attributes: selectedJson,
  //         branch_id: selectedBranch,
  //       }
  //     );

  //     if (response.data[0].STATUS === "SUCCESS") {
  //       const stock = response.data[0]?.DATA;
  //       if (stock == 0) {
  //         toast.error("Stock is not available!.", {
  //           position: "top-right",
  //           autoClose: 5000,
  //           hideProgressBar: false,
  //           closeOnClick: true,
  //           pauseOnHover: true,
  //           draggable: true,
  //         });
  //         setProductselectid("");
  //         setCartloading(false);
  //         setCartinfo("Data not found");
  //       } else {
  //         setCartloading(false);
  //         setCartinfo("Data found");
  //         handleAddToCart(
  //           selectedProduct,
  //           selectedUnits[selectedProduct.product_id] || 1,
  //           stock,
  //           selectedJson,
  //           selectedJson_Name,
  //           selectedprice
  //         );
  //       }

  //       // selectedJson !== "" && setShowattrmodal(!showattrmodal);
  //     } else {
  //       setCartloading(false);
  //     }
  //   } catch (error) {
  //     console.error("Error in getProductCategoryList API:", error);
  //   }
  // };

  // ─── 3. getBranchWiseProductCurrentStock — accept & forward sku ─────
  const getBranchWiseProductCurrentStock = async (
    selectedProduct,
    selectedJson,
    selectedJson_Name,
    selectedprice,
    sku_code = "" // ✅ NEW (optional — pricelist flow passes nothing)
  ) => {
    try {
      // ✅ Base payload — no Attributes
      const payload = {
        AUTHORIZEKEY: AUTHORIZE_KEY,
        product_id: selectedProduct?.product_id,
        branch_id: selectedBranch,
      };

      // ✅ Only pass Attributes when ecommerce config is OFF (pricelist flow)
      if (!ecommerce_on) {
        payload.Attributes = selectedJson;
      }

      const response = await axios.post(
        "/expo_access_api/getBranchWiseProductCurrentStock/",
        payload
      );

      if (response.data[0].STATUS === "SUCCESS") {
        const stock = response.data[0]?.DATA;
        if (stock == 0 && !withoutstockbypass) {   // ✅ only block when bypass is OFF
          toast.error("Stock is not available!.", {
            position: "top-right",
            autoClose: 5000,
          });
          setProductselectid("");
          setCartloading(false);
          setCartinfo("Data not found");
        } else {
          setCartloading(false);
          setCartinfo("Data found");
          handleAddToCart(
            selectedProduct,
            selectedUnits[selectedProduct.product_id] || 1,
            stock,
            selectedJson,
            selectedJson_Name,
            selectedprice,
            sku_code
          );
        }

        // only-close fix (was a toggle — see earlier note)
        if (selectedJson !== "" && showattrmodal) {
          setShowattrmodal(false);
        }
      } else {
        setCartloading(false);
      }
    } catch (error) {
      console.error("Error in getBranchWiseProductCurrentStock API:", error);
    }
  };

  const [company_arr, setCompanyarr] = useState([]);
  const [branch_arr, setBrancharr] = useState([]);

  useEffect(() => {
    if (company_arr?.length > 0 && !selectedCompany) {
      dispatch(setSelectedCompany(company_arr[0].company_id));
    }
  }, [company_arr, selectedCompany, dispatch]);

  // useEffect(() => {
  //   if (branch_arr?.length > 0 && !selectedBranch) {
  //     dispatch(setSelectedBranch(branch_arr[0].branch_id));
  //   }
  // }, [branch_arr, selectedBranch, dispatch]);

  // ✅ Auto-select branch when there is only ONE branch
  useEffect(() => {
    if (branch_arr?.length === 1 && !selectedBranch) {
      dispatch(setSelectedBranch(branch_arr[0].branch_id));
      setBranchError(false); // clear any "select branch first" highlight
    }
  }, [branch_arr, selectedBranch, dispatch]);

  const fetchBranches = () => {
    axios
      .post("/supportportalapi/branches/", {
        AUTHORIZEKEY: AUTHORIZE_KEY,
        PHPTOKEN: localStorage.getItem("id_token"),
      })
      .then((response) => {
        if (response.data[0].STATUS === "SUCCESS") {
          setBrancharr(response.data[0].DATA.branch_arr);
        }
      })
      .catch((error) => {
        console.error("Error fetching branches:", error);
      });
  };

  const fetchCompanies = () => {
    axios
      .post("/supportportalapi/companylist/", {
        AUTHORIZEKEY: AUTHORIZE_KEY,
        PHPTOKEN: localStorage.getItem("id_token"),
      })
      .then((response) => {
        if (response.data[0].STATUS === "SUCCESS") {
          setCompanyarr(response.data[0].DATA.company_arr);
        }
      })
      .catch((error) => {
        console.error("Error fetching companies:", error);
      });
  };

  useEffect(() => {
    fetchBranches();
    fetchCompanies();
  }, []);

  /* prev contact logic */
  const [contactmodal, setContactmodal] = useState(false);
  const togglecontact = () => {
    setContactmodal(!contactmodal);
    const fieldsToReset = [
      "name",
      "mobile",
      "email",
      "address_type",
      "address1",
      "address2",
      "area",
      "city",
      "zipcode",
    ];
    fieldsToReset.forEach((field) => setValue(field, ""));
  };

  // added by umang for add billing address
  const [nickname_billing, setNickNamebilling] = useState();
  const [address1_billing, setAddress1billing] = useState();
  const [address2_billing, setAddress2billing] = useState();
  const [area_billing, setAreabilling] = useState();
  const [city_billing, setCitybilling] = useState();
  const [selcountry_billing, setSelCountrybilling] = useState();
  const [selstate_billing, setSelStatebilling] = useState();
  const [zipcode_billing, setZipcodebilling] = useState();
  const [address_id, setAddressID] = useState("");
  const [billingmodal, setBillingmodal] = useState(false);
  const [billingadd, setBillingadd] = useState(false);

  // for select - option
  const [Address, setAddress] = useState([]);

  const togglebilling = () => {
    setBillingmodal(!billingmodal);
    setNickNamebilling("");
    setAddress1billing("");
    setAddress2billing("");
    setAreabilling("");
    setCitybilling("");
    setSelCountrybilling("India");
    setSelStatebilling("GUJARAT");
    setZipcodebilling("");
  };

  const handleChangeFieldbilling = (e) => {
    if (e.target.name == "txt_add_type_new_billing") {
      setNickNamebilling(e.target.value);
    } else if (e.target.name == "txt_add_new1_billing") {
      setAddress1billing(e.target.value);
    } else if (e.target.name == "txt_add_new2_billing") {
      setAddress2billing(e.target.value);
    } else if (e.target.name == "txt_city_new_billing") {
      setCitybilling(e.target.value);
    } else if (e.target.name == "txt_area_new_billing") {
      setAreabilling(e.target.value);
    } else if (e.target.name == "txt_zipcode_new_billing") {
      // Only allow digits, max 6 characters
      const val = e.target.value;
      const re = /^[0-9]*$/;
      if (re.test(val) && val.length <= 6) {
        setZipcodebilling(val);
      }
    } else if (e.target.name == "sel_state_new_billing") {
      setSelStatebilling(e.target.value);
    }
  };

  const fetchContactAddresses = async (
    contactid,
    {
      setBillingId = true,
      billingIdOverride = null,
      shippingIdOverride = null,
      sameAsBillingOverride = null,
    } = {}
  ) => {
    try {
      const url = baseurl + "/expo_access_api/getContactBillingAddressForBot/";

      // Fetch both billing and shipping addresses in parallel
      const [billingRes, shippingRes] = await Promise.all([
        axios.post(url, {
          AUTHORIZEKEY: AUTHORIZE_KEY,
          contact_id: contactid,
          billing_type: "Y",
          contact_type: 1,
        }),
        axios.post(url, {
          AUTHORIZEKEY: AUTHORIZE_KEY,
          contact_id: contactid,
          billing_type: "N",
          contact_type: 1,
        }),
      ]);

      const billingAddresses =
        billingRes.data[0].STATUS === "SUCCESS" ? billingRes.data[0].DATA : [];

      const shippingAddresses =
        shippingRes.data[0].STATUS === "SUCCESS" ? shippingRes.data[0].DATA : [];

      // Merge both, avoiding duplicates by address_id
      const allAddresses = [
        ...billingAddresses,
        ...shippingAddresses.filter(
          (s) => !billingAddresses.some((b) => b.address_id === s.address_id)
        ),
      ];

      setAddress(allAddresses);

      if (setBillingId) {
        const defaultBilling =
          billingIdOverride ||
          billingAddresses.find((a) => a.billing_flg === "Y")?.address_id ||
          allAddresses[0]?.address_id ||
          "";

        const defaultShipping =
          shippingIdOverride !== null
            ? shippingIdOverride
            : shippingAddresses.find((a) => a.billing_flg === "Y")?.address_id ||
            defaultBilling;

        const resolvedSameAsBilling =
          sameAsBillingOverride !== null
            ? sameAsBillingOverride
            : defaultBilling === defaultShipping;

        // ✅ KEY FIX: if sameAsBilling, force shippingAddressId = billingAddressId
        const finalShippingId = resolvedSameAsBilling
          ? defaultBilling
          : defaultShipping;

        dispatch(
          setAddressDetails({
            billingAddressId: defaultBilling,
            shippingAddressId: finalShippingId,
            sameAsBilling: resolvedSameAsBilling,
          })
        );

        if (defaultBilling) dispatch(setShowBillingModal(true));
        // Show shipping modal only when NOT same as billing
        if (!resolvedSameAsBilling) dispatch(setShowShippingModal(true));
      }
    } catch (error) {
      console.error("Error in fetchContactAddresses:", error);
      setAddress([]);
    }
  };



  const handleSubmitAddressBilling = (e) => {
    e.preventDefault();

    axios
      .post(baseurl + "/expo_access_api/saveContactAddress/", {
        AUTHORIZEKEY: AUTHORIZE_KEY,
        contact_id: contact_id,
        contact_type: 1,
        address_type: nickname_billing,
        address1: address1_billing,
        address2: address2_billing,
        area: area_billing,
        city: city_billing,
        selcountry: selcountry_billing,
        selstate: selstate_billing,
        zipcode: zipcode_billing,
        billing_flg: "Y",
        billing_type: 0,
      })
      .then((response) => {
        if (response.data[0].STATUS === "SUCCESS") {
          Swal.fire({
            title: response.data[0].MSG,
            icon: "success",
          });
          fetchContactAddresses(contact_id);
          setNickNamebilling("");
          setAddress1billing("");
          setAddress2billing("");
          setAreabilling("");
          setCitybilling("");
          setSelCountrybilling("India");
          setSelStatebilling("GUJARAT");
          setZipcodebilling("");
          togglebilling();
        } else {
          console.error(
            "Error in saveContactAddress API:",
            response.data[0].MSG
          );
        }
      })
      .catch((error) => {
        console.error("Error in saveContactAddress API:", error);
      });
  };

  // added by umang
  // for add shipping address
  const [nickname_shipping, setNickNameShipping] = useState();
  const [address1_shipping, setAddress1Shipping] = useState();
  const [address2_shipping, setAddress2Shipping] = useState();
  const [area_shipping, setAreaShipping] = useState();
  const [city_shipping, setCityShipping] = useState();
  const [selcountry_shipping, setSelCountryShipping] = useState();
  const [selstate_shipping, setSelStateShipping] = useState();
  const [zipcode_shipping, setZipcodeShipping] = useState();
  const [shippingmodal, setShippingmodal] = useState(false);
  const [shippigadd, setShippingadd] = useState(false);

  const toggleshipping = () => {
    setShippingmodal(!shippingmodal);
    setNickNameShipping("");
    setAddress1Shipping("");
    setAddress2Shipping("");
    setAreaShipping("");
    setCityShipping("");
    setSelCountryShipping("");
    setSelStateShipping("");
    setZipcodeShipping("");
  };

  const handleChangeFieldShipping = (e) => {
    if (e.target.name === "txt_add_type_new_shipping") {
      setNickNameShipping(e.target.value);
    } else if (e.target.name === "txt_add_new1_shipping") {
      setAddress1Shipping(e.target.value);
    } else if (e.target.name === "txt_add_new2_shipping") {
      setAddress2Shipping(e.target.value);
    } else if (e.target.name === "txt_city_new_shipping") {
      setCityShipping(e.target.value);
    } else if (e.target.name === "txt_area_new_shipping") {
      setAreaShipping(e.target.value);
    } else if (e.target.name === "txt_zipcode_new_shipping") {
      const val = e.target.value;
      const re = /^[0-9]*$/;
      if (re.test(val) && val.length <= 6) {
        setZipcodeShipping(val);
      }
    } else if (e.target.name === "sel_state_new_shipping") {
      setSelStateShipping(e.target.value);
    }
  };

  const handleSubmitAddressShipping = (e) => {
    e.preventDefault();

    axios
      .post(baseurl + "/expo_access_api/saveContactAddress/", {
        AUTHORIZEKEY: AUTHORIZE_KEY,
        contact_id: contact_id,
        contact_type: 1,
        address_type: nickname_shipping,
        address1: address1_shipping,
        address2: address2_shipping,
        area: area_shipping,
        city: city_shipping,
        selcountry: selcountry_shipping,
        selstate: selstate_shipping,
        zipcode: zipcode_shipping,
        billing_flg: "Y",
        billing_type: 1,
      })
      .then((response) => {
        if (response.data[0].STATUS === "SUCCESS") {
          Swal.fire({
            title: response.data[0].MSG,
            icon: "success",
          });
          fetchContactAddresses(contact_id);
          setNickNameShipping("");
          setAddress1Shipping("");
          setAddress2Shipping("");
          setAreaShipping("");
          setCityShipping("");
          setSelCountryShipping("India");
          setSelStateShipping("GUJARAT");
          setZipcodeShipping("");
          toggleshipping();
        } else {
          console.error(
            "Error in saveContactAddress API:",
            response.data[0].MSG
          );
        }
      })
      .catch((error) => {
        console.error("Error in saveContactAddress API:", error);
      });
  };

  const [contacts, setContacts] = useState([]);
  const [country, setCountry] = useState([]);
  const [State, setState] = useState([]);
  const [selcountry, setSelCountry] = useState("");
  const [addcontact, setAddContact] = useState({
    name: "",
    mobile: "",
    email: "",
    address_type: "",
    address1: "",
    address2: "",
    country: "",
    area: "",
    state: "",
    city: "",
    zipcode: "",
  });
  const [contactbtn, setContactbtn] = useState(false);

  const animatedComponents = makeAnimated();

  useEffect(() => {
    submitfile();
  }, []);

  const [defaultPosContact, setDefaultPosContact] = useState({});
  async function submitfile() {
    try {
      let url = "/expo_access_api/getContactTextile/";
      const res = await axios.post(url, {
        AUTHORIZEKEY: AUTHORIZE_KEY,
        created_by: 1,
      });

      if (res.data[0].STATUS === "SUCCESS") {
        const defaultContactId = userdetails?.default_con_for_pos;
        const defaultContact = defaultContactId
          ? res.data[0].DATA.find((contact) => contact.id == defaultContactId)
          : null;
        setDefaultPosContact(defaultContact || {});
        setContacts(res.data[0].DATA);
      }
    } catch (error) {
      console.error("Error in API call:", error);
    }
  }

  const getCountryList = (e) => {
    async function findCountryList() {
      try {
        let url = "/expo_access_api/getCountryList/";
        const res = await axios.post(url, {
          AUTHORIZEKEY: AUTHORIZE_KEY,
        });

        if (res.data[0].STATUS === "SUCCESS") {
          setCountry(res.data[0].DATA);
          setValue("country", "India");
          changestate(e, "India");
        }
      } catch (error) {
        console.error("Error in getCountryList API:", error);
      }
    }

    findCountryList();
  };

  const changestate = (e, val) => {
    var element_val = val === 0 ? e.target.value : val;
    setSelCountry(element_val);
    setSelCountrybilling(element_val);
    setSelCountryShipping(element_val);
    setAddContact({ ...addcontact, country: element_val });

    async function getStates() {
      try {
        const res = await axios.post(
          "/expo_access_api/getstatelist/",
          {
            AUTHORIZEKEY: AUTHORIZE_KEY,
            COUNTRY: element_val,
          }
        );

        if (res.data[0].STATUS === "SUCCESS") {
          if (res.data[0].DATA.state) {
            setState(res.data[0].DATA.state);
            setValue("state", "GUJARAT");
          }
        } else {
          Swal.fire("Not Found", "State Not Found", "error");
          setState([]);
        }
      } catch (error) {
        console.error("Error in getStates API:", error);
      }
    }

    getStates();
  };

  useEffect(() => {
    getCountryList();
  }, []);

  const handleSubmitContact = async (data, e) => {
    setContactbtn(true);
    e.preventDefault();

    async function submitContact() {
      try {
        let url = "/ecommerce_api/saveContactPOS/";
        const res = await axios.post(url, {
          contact: data,
        });

        if (res.data[0].STATUS == "SUCCESS" && res.data[0].DATA > 0) {
          const fieldsToReset = [
            "name",
            "mobile",
            "email",
            "address_type",
            "address1",
            "address2",
            "area",
            "city",
            "zipcode",
          ];
          fieldsToReset.forEach((field) => setValue(field, ""));

          await submitfile();
          const contactId = res.data[0].DATA;

          dispatch(setContactDetails({
            id: contactId,
            name: data.name,
            number: data.mobile
          }));

          setContactbtn(false);
          setContactmodal(!togglecontact);
          setBillingadd(true);
          Swal.fire("Good job!", "Contact " + res.data[0].MSG, "success");
          fetchContactAddresses(contactId);
        } else {
          Swal.fire("Something went wrong", res.data[0].MSG, "error");
          setContactbtn(false);
        }
      } catch (error) {
        console.error("Error in submitContact API:", error);
        setContactbtn(false);
      } finally {
        setContactbtn(false);
      }
    }

    submitContact();
  };

  const [selectedContact, setSelectedContact] = useState(null);
  useEffect(() => {
    const updatedSelectedContact = contacts.find(
      (contact) => contact.id == contact_id
    );
    setSelectedContact(updatedSelectedContact);
  }, [contact_id, contacts]);

  // Also update the handleSelectChange function:
  const handleSelectChange = (selectedOption) => {
    if (!selectedOption || !selectedOption.value) {
      // Clear case - reset contact
      dispatch(setContactDetails({
        id: "",
        name: "",
        number: ""
      }));
      setAddress([]);
      return;
    }

    dispatch(setContactDetails({
      id: selectedOption.value,
      name: selectedOption.contactname,
      number: selectedOption.mobile
    }));
    fetchContactAddresses(selectedOption.value);
    dispatch(setShowBillingModal(true));
    dispatch(setAddCustomerDetails(true));
  };

  // Add this useEffect to prevent checkbox flickering
  // const [localSameAsBilling, setLocalSameAsBilling] = useState(sameAsBilling);

  // // Sync local state with Redux state
  // useEffect(() => {
  //   setLocalSameAsBilling(sameAsBilling);
  // }, [sameAsBilling]);

  // Update handleCheckboxChange to use local state
  const handleCheckboxChange = () => {
    const newSameAsBilling = !sameAsBilling;

    dispatch(
      setAddressDetails({
        billingAddressId: Billingaddress_id,
        // ✅ KEY FIX: checking = copy billing into shipping
        shippingAddressId: newSameAsBilling ? Billingaddress_id : Shippingaddress_id,
        sameAsBilling: newSameAsBilling,
      })
    );

    if (newSameAsBilling) {
      dispatch(setShowShippingModal(false));
    } else {
      dispatch(setShowShippingModal(true));
    }
  };

  /***************** MANAGING CATEGORY AND PRODUCT DISPLAYS *****************/

  const [categoryData, setCategoryData] = useState([]);
  const [MaincategoryData, setMaincategoryData] = useState([]);
  const [allProducts, setAllProducts] = useState([]);
  const [displayFilteredItems, setDisplayFilteredItems] = useState([]);

  const [categoryProducts, setCategoryProducts] = useState([]);
  const [isSelected, setIsSelected] = useState("");

  const [loading, setLoading] = useState(true);
  const [category_info, setCategoryinfo] = useState("");
  const [product_info, setProductinfo] = useState("");

  // Maincategories
  const fetchMaincategories = async () => {
    try {
      const response = await axios.post(
        "/ecommerce_api/getProductCategoryList/",
        {
          tree: true,
          AUTHORIZEKEY: AUTHORIZE_KEY,
          PHPTOKEN: localStorage.getItem("id_token"),
        }
      );

      if (response.data[0].STATUS === "SUCCESS") {
        setMaincategoryData(response.data[0].DATA.categorylist);
      } else {
        setMaincategoryData([]);
        setCategoryinfo("Data Not Found");
      }
    } catch (error) {
      console.error("Error in getProductCategoryList API:", error);
    }
  };

  useEffect(() => {
    fetchMaincategories();
  }, []);

  // Subcategories
  const fetchSubcategories = async () => {
    try {
      const response = await axios.post(
        "/ecommerce_api/getProductCategoryList/",
        {
          tree: false,
          AUTHORIZEKEY: AUTHORIZE_KEY,
          PHPTOKEN: localStorage.getItem("id_token"),
        }
      );

      if (response.data[0].STATUS === "SUCCESS") {
        setCategoryData(response.data[0].DATA.categorylist);
      } else {
        setCategoryData([]);
      }
    } catch (error) {
      console.error("Error in getProductCategoryList API:", error);
    }
  };

  useEffect(() => {
    fetchSubcategories();
  }, []);

  useEffect(() => {
    setLoading(true);

    const fetchData = async () => {
      try {
        const response = await axios.post(
          "/ecommerce_api/getCategorywiseProductList/",
          {
            category_name: "ALL",
          }
        );

        if (response.data[0].STATUS === "SUCCESS") {
          const data = response.data[0]?.DATA;
          const filteredItems = data ? data.products : [];

          if (filteredItems && filteredItems.length > 0) {
            setAllProducts(filteredItems);
            setDisplayFilteredItems(filteredItems);
          } else {
            setDisplayFilteredItems([]);
          }
        } else {
          console.error("Error fetching data:", response.data[0].MSG);
        }
      } catch (error) {
        console.error("Error in getCategorywiseProductList API:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // fetchCategorywiseProductList
  const fetchCategorywiseProductList = async () => {
    setProductinfo("Data Found");
    setDisplayFilteredItems([]);
    try {
      const response = await axios.post(
        "/ecommerce_api/getCategorywiseProductList/",
        {
          category_name: selectedCategory,
        }
      );

      if (response.data[0].STATUS === "SUCCESS") {
        const data = response.data[0]?.DATA;
        const fetchedItems = data ? data.products : [];
        setCategoryProducts(fetchedItems);
        setDisplayFilteredItems(fetchedItems);
      } else {
        console.error("Error fetching data:", response.data[0].MSG);
        setCategoryProducts([]);
        setDisplayFilteredItems([]);
        setProductinfo("Data Not Found");
      }
    } catch (error) {
      console.error("Error in getCategorywiseProductList API:", error);
      setCategoryProducts([]);
      setDisplayFilteredItems([]);
      setProductinfo("Data Not Found");
    } finally {
      setLoading(false);
      setProductinfo("Data Not Found");
    }
  };

  const getProductByBarcode = async (bar_code) => {
    if (!selectedBranch) {
      toast.error("Please select a branch first.", {
        position: "top-right",
        autoClose: 3000,
      });
      return;
    }
    try {
      const response = await axios.post(
        "/expo_access_api/ProductdetailByBarcode/",
        {
          barcode: bar_code,
          AUTHORIZEKEY: AUTHORIZE_KEY,
        }
      );

      if (!response.data || typeof response.data !== 'object') {
        throw new Error("Invalid API response structure");
      }

      if (Array.isArray(response.data) && response.data.length == 0) {
        throw new Error("No product data returned");
      }

      if (response.data[0]?.STATUS == "SUCCESS") {
        const data = response.data[0]?.DATA;

        if (!data || !data.Product_Details || !Array.isArray(data.Product_Details)) {
          throw new Error("Invalid product data structure");
        }

        const fetchedItems = data.Product_Details;
        const item = fetchedItems[0];

        if (item) {
          await getProductPriceList(item, item.product_id, item.name, "");
        } else {
          throw new Error("No product details available");
        }
      } else {
        const errorMessage = response.data[0]?.DATA?.MSG || "Product not available";
        throw new Error(errorMessage);
      }
    } catch (error) {
      console.error("API Error:", error);
      toast.error(error.message || "Error fetching product data", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  useEffect(() => {
    if (!selectedCategory) {
      return;
    }

    setLoading(true);
    fetchCategorywiseProductList();
  }, [selectedCategory]);

  const handleCategoryClick = (clickedCategory) => {
    if (isInvoiceSaved) {
      toast.error("Invoice already saved. You can print this invoice or share it on WhatsApp. To create a new invoice, click 'New'.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      return;
    }
    dispatch(setSelectedCategory(clickedCategory));
    setProductinfo("Data Found");
  };

  const handleCategorySearchChange = (event) => {
    dispatch(setCategorySearchQuery(event.target.value.toLowerCase()));
  };

  const [filteredCategories, setFilteredCategories] = useState([]);
  const [categoriesToDisplay, setCategoriesToDisplay] = useState([]);

  useEffect(() => {
    const fetchFilteredCategories = async () => {
      try {
        const filteredCategoriesResult = categoryData.filter((item) => {
          return item.name
            .toLowerCase()
            .includes(categorySearchQuery.toLowerCase());
        });
        if (filteredCategoriesResult.length == 0 && categorySearchQuery != "") {
          setCategoryinfo("Data Not Found");
        } else {
        }
        setFilteredCategories(filteredCategoriesResult);
      } finally {
      }
    };

    fetchFilteredCategories();
  }, [categoryData, categorySearchQuery]);

  useEffect(() => {
    setCategoriesToDisplay(
      categorySearchQuery ? filteredCategories : categoryData
    );
  }, [categorySearchQuery, filteredCategories, categoryData]);

  /************************ SEARCH *************************/
  useEffect(() => {
    if (categoryProducts.length == 0) {
      const filteredItems = allProducts.filter((item) => {
        const isNameMatch = item.name
          .toLowerCase()
          .includes(searchQuery.toLowerCase());
        const isIdMatch = item.product_id.toString() === searchQuery.trim();
        return isNameMatch || isIdMatch;
      });
      if (filteredItems.length == 0 && searchQuery != "") {
        setProductinfo("Data Not Found");
      } else {
      }
      setDisplayFilteredItems(filteredItems);
    } else {
      const filteredItems = categoryProducts.filter((item) => {
        const isNameMatch = item.name
          .toLowerCase()
          .includes(searchQuery.toLowerCase());
        const isIdMatch = item.product_id.toString() === searchQuery.trim();
        return isNameMatch || isIdMatch;
      });
      if (filteredItems.length == 0 && searchQuery != "") {
        setProductinfo("Data Not Found");
      } else {
      }
      setDisplayFilteredItems(filteredItems);
    }
  }, [searchQuery, categoryProducts]);

  /**************** DRAFTS ****************/

  const notifyDraft = () =>
    toast.success("Added to Drafts!", {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });

  const addDraft = (draft) => {
    dispatch(addDraftItem(draft));
    notifyDraft();
  };

  const clearCart = () => {
    dispatch(clearCartAction());
  };

  const refillCartFromDraft = (draft) => {
    const updatedSelectedUnits = draft.items.reduce((acc, item, index) => {
      acc[index] = item.selectedUnit;
      return acc;
    }, {});

    dispatch(setSelectedUnits(updatedSelectedUnits));
    dispatch(setCart(draft.items));

    // Calculate and set subTArray
    const newSubTArray = draft.items.map((item, i) =>
      calculateSubT(item, updatedSelectedUnits[i] || 1)
    );
    dispatch(setSubTArray(newSubTArray));
  };

  // ✅ Refetch addresses on page refresh if contact_id exists in Redux
  useEffect(() => {
    if (contact_id && addCustomerDetails) {
      fetchContactAddresses(contact_id, {
        setBillingId: false, // ✅ Don't override existing Redux address values
        billingIdOverride: Billingaddress_id,
        shippingIdOverride: Shippingaddress_id,
        sameAsBillingOverride: sameAsBilling,
      });
    }
  }, []); // ✅ Empty array = runs only once on mount

  const handleEdit = (draft, drafts) => {
    if (isInvoiceSaved) {
      toast.error("Invoice already saved. You can print this invoice or share it on WhatsApp. To create a new invoice, click 'New'.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      return;
    }

    // Clear current state first
    dispatch(resetForNewInvoice());

    // Wait for state to clear before refilling
    setTimeout(() => {
      refillCartFromDraft(draft);

      // ✅ Restore company & branch from draft
      if (draft.selectedCompany) {
        dispatch(setSelectedCompany(draft.selectedCompany));
      }
      if (draft.selectedBranch) {
        dispatch(setSelectedBranch(draft.selectedBranch));
      }

      if (draft.contactid != "") {
        dispatch(setAddCustomerDetails(true));
        dispatch(setContactDetails({
          id: draft.contactid,
          name: draft.contactName,
          number: draft.contactMobileNumber
        }));

        // ✅ Set ALL address details from draft FIRST - CRITICAL FIX
        dispatch(setAddressDetails({
          billingAddressId: draft.BillingaddressId || "",
          shippingAddressId: draft.ShippingaddressId || "",
          sameAsBilling: draft.Ship_Bill_Same || false // ✅ Use draft's value, default to false if undefined
        }));

        // ✅ Set modal visibility based on sameAsBilling from draft
        if (draft.Ship_Bill_Same) {
          dispatch(setShowBillingModal(true));
          dispatch(setShowShippingModal(false));
        } else {
          dispatch(setShowBillingModal(true));
          dispatch(setShowShippingModal(true));
        }

        // ✅ Only fetch addresses if needed (for dropdown population)
        // But DON'T let it override our draft values
        if (draft.contactid) {
          // Create a modified version of contact_address_draft that doesn't override addresses
          fetchContactAddresses(draft.contactid, {
            setBillingId: true,
            billingIdOverride: draft.BillingaddressId || "",
            shippingIdOverride: draft.ShippingaddressId || "",
            sameAsBillingOverride: draft.Ship_Bill_Same ?? false,
          });
        }
      } else {
        // If no contact, set to defaults
        dispatch(setAddCustomerDetails(false));
        dispatch(setShowBillingModal(false));
        dispatch(setShowShippingModal(false));
      }

      // Remove draft after refilling
      dispatch(removeDraftItem(draft));
      dispatch(toggleModal());
    }, 100);
  };

  // ✅ Add this new function to fetch addresses ONLY for dropdown, not to override
  // const fetchAddressesForDropdownOnly = async (contactid, billingAddressId, shippingAddressId) => {
  //   try {
  //     let url = baseurl + "/expo_access_api/getContactBillingAddressForBot/";
  //     const res = await axios.post(url, {
  //       AUTHORIZEKEY: AUTHORIZE_KEY,
  //       contact_id: contactid,
  //       billing_type: "Y",
  //       contact_type: 1,
  //     });

  //     if (res.data[0].STATUS === "SUCCESS") {
  //       // ✅ Only set the Address state for dropdown, don't dispatch any address details
  //       setAddress(res.data[0].DATA);
  //     } else {
  //       console.error("Error fetching data:", res.data[0].MSG);
  //       setAddress([]);
  //     }
  //   } catch (error) {
  //     console.error("Error in getContactBillingAddressForBot API:", error);
  //     setAddress([]);
  //   }
  // };

  const handleDelete = (draft, drafts) => {
    Swal.fire({
      title: 'Delete Draft?',
      html: `
      <div style="text-align: center;">
        <p>Are you sure you want to delete this draft?</p>
        <p style="font-size: 14px; color: #666;">
          <strong>Contact:</strong> ${draft.contactName || 'No Contact'} <br/>
          <strong>Items:</strong> ${draft.numberOfItems} <br/>
          <strong>Total:</strong> ₹${parseFloat(draft.total).toFixed(2)}
        </p>
        <p style="font-size: 12px; color: #999;">
          This action cannot be undone.
        </p>
      </div>
    `,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel',
      reverseButtons: true,
      focusCancel: true,
      customClass: {
        confirmButton: 'btn btn-danger',
        cancelButton: 'btn btn-secondary'
      }
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(removeDraftItem(draft));

        Swal.fire({
          title: 'Deleted!',
          text: 'Draft has been deleted.',
          icon: 'success',
          timer: 1500,
          showConfirmButton: false
        });

        if (drafts.length === 1) {
          setTimeout(() => {
            dispatch(toggleModal());
          }, 1500);
        }
      }
    });
  };

  /********************************* CART *********************************/

  const [cart_loading, setCartloading] = useState(false);
  const [cart_info, setCartinfo] = useState("Data not found");

  useEffect(() => {
    if (cart.length === 0) {
      setCartinfo("Data not found");
    } else {
      setCartinfo("Data found");
    }
  }, [cart]);

  // const handleAddToCart = (
  //   selectedProduct,
  //   selectedUnit,
  //   prod_stock,
  //   selectedJson,
  //   selectedJson_Name,
  //   selectedprice
  // ) => {
  //   const existingProductIndex = cart.findIndex(
  //     (item) =>
  //       item.product_id == selectedProduct.product_id &&
  //       item.stock == prod_stock
  //   );

  //   let updatedCart;

  //   if (existingProductIndex !== -1) {
  //     // Update existing product quantity
  //     updatedCart = cart.map((item, idx) => {
  //       if (idx === existingProductIndex) {
  //         const newQuantity = item.quantity + 1;
  //         const validatedQuantity = Math.max(0, newQuantity);

  //         if (validatedQuantity > parseFloat(item.stock, 10)) {
  //           setInvalidInput(existingProductIndex);
  //           toast.error("Quantity should not be greater than available stock.", {
  //             position: "top-right",
  //             autoClose: 5000,
  //             hideProgressBar: false,
  //             closeOnClick: true,
  //             pauseOnHover: true,
  //             draggable: true,
  //           });
  //           return item;
  //         }

  //         setInvalidInput(null);

  //         // Calculate new values
  //         const selectedUnit = selectedUnits[existingProductIndex] || 1;
  //         const subtotal = calculateSubT({ ...item, quantity: validatedQuantity }, selectedUnit);
  //         const discount = calculateDiscount({ ...item, quantity: validatedQuantity }, selectedUnit);
  //         const validDiscount = !isNaN(discount) ? discount : 0;
  //         const tax = (subtotal * item.taxPercentage) / 100;
  //         const discountedSubtotal = subtotal - validDiscount;
  //         const total = discountedSubtotal + tax;

  //         return {
  //           ...item,
  //           quantity: validatedQuantity,
  //           discount,
  //           amount: total.toFixed(2),
  //         };
  //       }
  //       return item;
  //     });
  //   } else {
  //     // Add new product
  //     const newCartItem = {
  //       product_id: selectedProduct.product_id,
  //       name: selectedProduct.name,
  //       mrp_price: selectedprice || selectedProduct.price1_min,
  //       original_photo_path: selectedProduct.original_photo_path,
  //       quantity: 1,
  //       packing: selectedProduct.proddivision,
  //       unit_name: selectedProduct.unit_name,
  //       second_unit: selectedProduct.second_unit,
  //       conv_factor: selectedProduct.prod_conversion,
  //       taxPercentage: selectedProduct.Tax,
  //       selectedUnit: selectedUnit || 1,
  //       stock: Number(prod_stock),
  //       product_attribute: selectedJson,
  //       product_attribute_Name: JSON.parse(JSON.stringify(selectedJson_Name)),
  //       productstockid: !!selectedProduct.ProductStockid
  //         ? selectedProduct.ProductStockid
  //         : "",
  //       discount: 0,
  //       discountPercentage: 0,
  //       amount: selectedprice || selectedProduct.price1_min,
  //     };

  //     updatedCart = [...cart, newCartItem];

  //     // Update selected units for new item
  //     const newSelectedUnits = { ...selectedUnits };
  //     newSelectedUnits[updatedCart.length - 1] = selectedUnit || 1;
  //     dispatch(setSelectedUnits(newSelectedUnits));
  //   }

  //   dispatch(setCart(updatedCart));

  //   // Recalculate subTArray
  //   const newSubTArray = updatedCart.map((item, i) =>
  //     calculateSubT(item, selectedUnits[i] || 1)
  //   );
  //   dispatch(setSubTArray(newSubTArray));

  //   setProductselectid("");
  // };

  // ─── 4. handleAddToCart — match on variant key, not stock ───────────
  const handleAddToCart = (
    selectedProduct,
    selectedUnit,
    prod_stock,
    selectedJson,
    selectedJson_Name,
    selectedprice,
    sku_code = "" // ✅ NEW
  ) => {
    // ✅ Stable identity for this exact product+attribute combination
    const variantKey = buildVariantKey(
      selectedProduct.product_id,
      sku_code,
      selectedJson
    );

    // ✅ Match on variantKey (fallback to old product_id+stock match for
    //    legacy cart lines that were added before this change)
    const existingProductIndex = cart.findIndex((item) =>
      item.variant_key
        ? item.variant_key === variantKey
        : item.product_id == selectedProduct.product_id &&
        item.stock == prod_stock
    );

    let updatedCart;

    if (existingProductIndex !== -1) {
      // ── SAME VARIANT selected again → increment qty only ──
      // Industry standard: keep the line's existing rate (the cashier
      // may have edited it). Warn if the variant price has changed.
      const existingItem = cart[existingProductIndex];
      if (
        selectedprice &&
        Number(existingItem.mrp_price) !== Number(selectedprice)
      ) {
        toast.info(
          `"${existingItem.name}" is already in the cart at ₹${existingItem.mrp_price}. Quantity increased — rate unchanged.`,
          { position: "top-right", autoClose: 4000 }
        );
      }

      updatedCart = cart.map((item, idx) => {
        if (idx === existingProductIndex) {
          // const newQuantity = item.quantity + 1; //comment out the +1 to avoid incrementing quantity automatically for kapadvanjhaat
          const newQuantity = item.quantity;
          const validatedQuantity = Math.max(0, newQuantity);

          if (validatedQuantity > parseFloat(item.stock, 10) && !withoutstockbypass) {
            setInvalidInput(existingProductIndex);
            toast.error(
              "Quantity should not be greater than available stock.",
              { position: "top-right", autoClose: 5000 }
            );
            return item;
          }

          setInvalidInput(null);

          const unit = selectedUnits[existingProductIndex] || 1;
          const subtotal = calculateSubT(
            { ...item, quantity: validatedQuantity },
            unit
          );
          const discount = calculateDiscount(
            { ...item, quantity: validatedQuantity },
            unit
          );
          const validDiscount = !isNaN(discount) ? discount : 0;
          const tax = (subtotal * item.taxPercentage) / 100;
          const total = subtotal - validDiscount + tax;

          return {
            ...item,
            quantity: validatedQuantity,
            stock: Number(prod_stock), // refresh latest stock
            discount,
            amount: total.toFixed(2),
          };
        }
        return item;
      });
    } else {
      // ── NEW VARIANT (or new product) → new cart line ──
      const newCartItem = {
        product_id: selectedProduct.product_id,
        variant_key: variantKey, // ✅ store identity on the line
        sku_code: sku_code || "", // ✅ useful for invoice/backend
        name: selectedProduct.name,
        mrp_price: selectedprice || selectedProduct.price1_min,
        original_photo_path: selectedProduct.original_photo_path,
        quantity: "",
        packing: selectedProduct.proddivision,
        unit_name: selectedProduct.unit_name,
        second_unit: selectedProduct.second_unit,
        conv_factor: selectedProduct.prod_conversion,
        taxPercentage: selectedProduct.Tax,
        selectedUnit: selectedUnit || 1,
        stock: Number(prod_stock),
        product_attribute: selectedJson,
        product_attribute_Name: selectedJson_Name
          ? JSON.parse(JSON.stringify(selectedJson_Name))
          : {},
        productstockid: !!selectedProduct.ProductStockid
          ? selectedProduct.ProductStockid
          : "",
        discount: 0,
        discountPercentage: 0,
        amount: selectedprice || selectedProduct.price1_min,
      };

      updatedCart = [...cart, newCartItem];

      const newSelectedUnits = { ...selectedUnits };
      newSelectedUnits[updatedCart.length - 1] = selectedUnit || 1;
      dispatch(setSelectedUnits(newSelectedUnits));
    }

    dispatch(setCart(updatedCart));

    const newSubTArray = updatedCart.map((item, i) =>
      calculateSubT(item, selectedUnits[i] || 1)
    );
    dispatch(setSubTArray(newSubTArray));
    dispatch(setShowQtyRed(false));   // ← ADD THIS
    setInvalidInput(null);            // ← ADD THIS

    setProductselectid("");
  };

  const handleRemoveFromCart = (productId, index) => {
    dispatch(removeFromCart(index));

    // Recalculate subTArray after removal
    const newCart = cart.filter((item, i) => i !== index);
    const newSubTArray = newCart.map((item, i) =>
      calculateSubT(item, selectedUnits[i] || 1)
    );
    dispatch(setSubTArray(newSubTArray));
  };

  const [invalidInput, setInvalidInput] = useState(null);

  // Fix handleQuantityInputChange:
  const handleQuantityInputChange = (rowIndex, newQuantity) => {
    // Create a new cart array instead of modifying existing one
    const updatedCart = cart.map((item, idx) => {
      if (idx === rowIndex) {
        const validatedQuantity = Math.max(0, parseFloat(newQuantity, 10) || 0);

        if (validatedQuantity > parseFloat(item.stock, 10) && !withoutstockbypass) {
          setInvalidInput(rowIndex);
          toast.error("Quantity should not be greater than available stock.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          return item; // Return unchanged item
        }
        setInvalidInput(null);

        // Calculate new values
        const selectedUnit = selectedUnits[rowIndex] || 1;
        const subtotal = calculateSubT({ ...item, quantity: validatedQuantity }, selectedUnit);
        const discount = calculateDiscount({ ...item, quantity: validatedQuantity }, selectedUnit);
        const validDiscount = !isNaN(discount) ? discount : 0;
        const tax = (subtotal * item.taxPercentage) / 100;
        const discountedSubtotal = subtotal - validDiscount;
        const total = discountedSubtotal + tax;

        // Return new object with updated values
        return {
          ...item,
          quantity: validatedQuantity,
          discount,
          amount: total.toFixed(2),
        };
      }
      return item;
    });

    dispatch(setCart(updatedCart));

    // Recalculate subTArray
    const newSubTArray = updatedCart.map((item, i) =>
      calculateSubT(item, selectedUnits[i] || 1)
    );
    dispatch(setSubTArray(newSubTArray));
  };

  const handleChangeRate = (rowIndex, newRate) => {
    const updatedCart = cart.map((item, idx) => {
      if (idx === rowIndex) {
        const validatedRate = Math.max(0, parseFloat(newRate) || 0);
        setInvalidInput(null);

        const selectedUnit = selectedUnits[rowIndex] || 1;
        const subtotal = calculateSubT({ ...item, mrp_price: validatedRate }, selectedUnit);
        const discount = calculateDiscount({ ...item, mrp_price: validatedRate }, selectedUnit);
        const validDiscount = !isNaN(discount) ? discount : 0;
        const tax = (subtotal * item.taxPercentage) / 100;
        const discountedSubtotal = subtotal - validDiscount;
        const total = discountedSubtotal + tax;

        return {
          ...item,
          mrp_price: validatedRate,
          discount,
          amount: total.toFixed(2),
        };
      }
      return item;
    });

    dispatch(setCart(updatedCart));

    // Recalculate subTArray
    const newSubTArray = updatedCart.map((item, i) =>
      calculateSubT(item, selectedUnits[i] || 1)
    );
    dispatch(setSubTArray(newSubTArray));
  };

  /************************* DATA TABLE *************************/

  const style2 = { width: 25, fontSize: 14, padding: 1 };

  const [unitChangeCount, setUnitChangeCount] = useState(0);

  useEffect(() => {
    const updatedSubTArray = cart.map((item, i) =>
      calculateSubT(item, selectedUnits[i] || 1)
    );
    dispatch(setSubTArray(updatedSubTArray));
  }, [cart, unitChangeCount, selectedUnits, dispatch]);

  const calculateSubT = (item, selectedUnit) => {
    const quantity = Number(item.quantity);
    const mrpPrice = Number(item.mrp_price);
    const convFactor = Number(item.conv_factor) || 1;

    if (Number(selectedUnit) === 1) {
      return mrpPrice * quantity;
    } else if (Number(selectedUnit) === 2) {
      return (quantity / convFactor) * mrpPrice;
    } else {
      return 0;
    }
  };

  const calculateTax = (item, selectedUnit, index) => {
    const taxPercentage = Number(item.taxPercentage);
    const taxAmount = (subTArray[index] * taxPercentage) / 100;
    return taxAmount.toFixed(2);
  };

  const handleUnitChange = (index, selectedUnit) => {
    // Update selected units
    dispatch(updateSelectedUnit({ index, unit: selectedUnit }));

    // Update cart item
    const updatedCart = cart.map((item, idx) => {
      if (idx === index) {
        const newSubT = calculateSubT({ ...item, selectedUnit: Number(selectedUnit) }, selectedUnit);
        const discount = calculateDiscount({ ...item, selectedUnit: Number(selectedUnit) }, selectedUnit);
        const validDiscount = !isNaN(discount) ? discount : 0;
        const tax = (newSubT * item.taxPercentage) / 100;
        const discountedSubtotal = newSubT - validDiscount;
        const total = discountedSubtotal + tax;

        return {
          ...item,
          selectedUnit: Number(selectedUnit),
          discount,
          amount: total.toFixed(2),
        };
      }
      return item;
    });

    dispatch(setCart(updatedCart));

    // Recalculate subT
    const newSubT = calculateSubT(cart[index], selectedUnit);
    const updatedSubTArray = [...subTArray];
    updatedSubTArray[index] = newSubT;
    dispatch(setSubTArray(updatedSubTArray));

    setUnitChangeCount((prevCount) => prevCount + 1);
  };

  const productColumns = [
    {
      name: "Image",
      selector: (row) => (
        <div className="popover-attribute">
          <OverlayTrigger
            trigger="hover"
            key={row.id}
            placement="right"
            overlay={
              <Popover id={`popover-positioned-${row.id}`}>
                <Popover.Header as="h3">{row.name}</Popover.Header>
                <Popover.Body>
                  <ul>
                    {row.product_attribute_Name[row.product_id] ? (
                      <ul>
                        {Object.entries(
                          row.product_attribute_Name[row.product_id]
                        ).map(
                          ([attribute, value]) =>
                            value && (
                              <li key={attribute}>
                                <strong style={{ fontWeight: "bolder" }}>
                                  {attribute}:
                                </strong>{" "}
                                {value}
                              </li>
                            )
                        )}
                      </ul>
                    ) : (
                      <span>No attributes available</span>
                    )}
                  </ul>
                </Popover.Body>
              </Popover>
            }
          >
            <img
              height="45px"
              width="45px"
              alt={row.name}
              src={row.original_photo_path}
              padding="0"
              style={{ borderRadius: "6px", cursor: "pointer" }}
            />
          </OverlayTrigger>
        </div>
      ),
      sortable: true,
      center: true,
      minWidth: "70px",
      maxWidth: "70px",
    },
    {
      name: "Product",
      selector: (row) => (
        <span style={{ paddingRight: "5px" }}>{row.name}</span>
      ),
      sortable: true,
      center: true,
      wrap: true,
      minWidth: "120px",
    },
    {
      name: "Unit",
      cell: (row, index) =>
        index !== cart.length ? (
          <Form.Select
            aria-label="Default select example"
            size="sm"
            style={{ width: "80px", padding: "4px", maxHeighteight: "25px", cursor: isInvoiceSaved ? 'not-allowed' : 'pointer', opacity: isInvoiceSaved ? 0.75 : 1 }}
            onChange={(e) => {
              handleUnitChange(index, e.target.value, row);
            }}
            disabled={isInvoiceSaved}
          >
            {row.unit_name != "" && (
              <option value="1" selected={row.selectedUnit == 1}>
                {row.unit_name}
              </option>
            )}
            {row.second_unit != "" && (
              <option value="2" selected={row.selectedUnit == 2}>
                {row.second_unit}
              </option>
            )}
          </Form.Select>
        ) : null,
      sortable: true,
      center: true,
      minWidth: "100px",
      maxWidth: "100px",
      padding: "0",
    },
    {
      name: "Qty",
      cell: (row, index) =>
        index != cart.length ? (
          <div
            className={`qty-input-grp d-flex-row${invalidInput == index || (showQtyRed && row.quantity == 0)
              ? " qty-input-grp-red"
              : ""
              }`}
          >
            <Form.Control
              type="number"
              size="sm"
              value={row.quantity.toString()}
              onChange={(e) => handleQuantityInputChange(index, e.target.value)}
              style={{ width: "70px", cursor: isInvoiceSaved ? 'not-allowed' : 'text', opacity: isInvoiceSaved ? 0.75 : 1 }}
              disabled={isInvoiceSaved}
            />
          </div>
        ) : null,
      selector: (row) => row.quantity,
      sortable: true,
      center: true,
      minWidth: "95px",
      maxWidth: "110px",
    },
    {
      name: "Stock",
      selector: (row) => (
        <span style={{ paddingLeft: "5px" }}>{row.stock}</span>
      ),
      sortable: true,
      center: true,
      minWidth: "65px",
      maxWidth: "65px",
    },
    {
      name: "Rate",
      cell: (row, index) =>
        index !== cart.length ? (
          <Form.Control
            type="number"
            size="sm"
            value={row.mrp_price ? row.mrp_price.toString() : ""}
            onChange={(e) => handleChangeRate(index, e.target.value)}
            style={{ width: "70px", cursor: isInvoiceSaved ? 'not-allowed' : 'text', opacity: isInvoiceSaved ? 0.75 : 1 }}
            disabled={isInvoiceSaved}
          />
        ) : null,
      sortable: true,
      center: true,
      minWidth: "85px",
      maxWidth: "85px",
    },
    {
      name: (
        <span>
          Gross
          <br />
          Amount
        </span>
      ),
      selector: (row, index) => Number(subTArray[index]).toFixed(2),
      sortable: true,
      center: true,
      minWidth: "90px",
      maxWidth: "90px",
    },
    {
      name: (
        <span>
          Disc
          <br />
          (%)
        </span>
      ),
      cell: (row, index) =>
        index !== cart.length ? (
          <Form.Control
            type="text"
            size="sm"
            value={row.discountPercentage}
            onChange={(e) =>
              handleDiscountChange(index, "percentage", e.target.value)
            }
            disabled={isInvoiceSaved}
            style={{ cursor: isInvoiceSaved ? 'not-allowed' : 'text', opacity: isInvoiceSaved ? 0.75 : 1 }}
          />
        ) : null,
      sortable: true,
      center: true,
      minWidth: "85px",
      maxWidth: "85px",
    },
    {
      name: "Disc",
      cell: (row, index) =>
        index !== cart.length ? (
          <Form.Control
            type="text"
            size="sm"
            value={row.discount}
            onChange={(e) =>
              handleDiscountChange(index, "amount", e.target.value)
            }
            style={{ width: "70px", cursor: isInvoiceSaved ? 'not-allowed' : 'text', opacity: isInvoiceSaved ? 0.75 : 1 }}
            disabled={isInvoiceSaved}
          />
        ) : null,
      sortable: true,
      center: true,
      minWidth: "75px",
      maxWidth: "75px",
    },
    {
      name: (
        <span>
          Tax
          <br />
          (%)
        </span>
      ),
      selector: (row) => row.taxPercentage,
      sortable: true,
      center: true,
      minWidth: "45px",
      maxWidth: "45px",
    },
    {
      name: "Tax",
      selector: (row, index) => calculateTax(row, selectedUnits[index], index),
      sortable: true,
      center: true,
      minWidth: "65px",
      maxWidth: "65px",
    },
    {
      name: (
        <span>
          Payable
          <br />
          Amount
        </span>
      ),
      selector: (row, index) => row.amount,
      sortable: true,
      center: true,
      minWidth: "70px",
      maxWidth: "150px",
    },
    {
      name: "",
      cell: (row, index) => (
        <div>
          <span>
            <button
              style={{
                width: 25,
                fontSize: 14,
                padding: 1,
                textAlign: "center",
              }}
              color="danger"
              className="btn btn-xs"
              type="button"
              onClick={() => handleRemoveFromCart(row.product_id, index)}
              disabled={isInvoiceSaved}
            >
              <Btn
                attrBtn={{
                  style: style2,
                  color: "danger",
                  className: "btn btn-xs action-button",
                  type: "button",
                  disabled: isInvoiceSaved
                }}
              >
                <FiTrash size={15} />
              </Btn>
            </button>
          </span>
        </div>
      ),
      sortable: false,
      center: true,
      minWidth: "35px",
      maxWidth: "35px",
    },
  ];

  /************************* BILL SUMMARY *************************/
  const calculateBillSummary = () => {
    const totalItems = cart.length;
    const actualTotalPrice = cart.reduce((total, item, index) => {
      return total + subTArray[index];
    }, 0);

    const totalTaxes = cart.reduce((total, item, index) => {
      const taxRate = Number.isFinite(item.taxPercentage)
        ? item.taxPercentage / 100
        : 0;
      const itemTax = subTArray[index] * taxRate || 0;
      return total + itemTax;
    }, 0);

    const totalDiscount = cart.reduce((total, item) => {
      return total + Number(item.discount);
    }, 0);

    const baseTotal = actualTotalPrice + totalTaxes - totalDiscount; // ✅ before adjustment

    const adjAmount = parseFloat(adjustmentValue) || 0;
    const overallTotal =
      adjustmentType === "add" ? baseTotal + adjAmount : baseTotal - adjAmount;

    return {
      totalItems,
      actualTotalPrice: Number(actualTotalPrice.toFixed(2)),
      totalDiscount: Number(totalDiscount.toFixed(2)),
      totalTaxes: Number(totalTaxes.toFixed(2)),
      baseTotal: Number(baseTotal.toFixed(2)),     // ✅ new
      overallTotal: Number(overallTotal.toFixed(2)),
    };
  };

  const [billSummary, setBillSummary] = useState(calculateBillSummary());

  // type="text" but only allow a number with up to 2 decimals
  const handleAdjustmentValueChange = (e) => {
    const val = e.target.value;
    if (val === "" || /^\d*\.?\d{0,2}$/.test(val)) {
      setAdjustmentValue(val);
    }
  };

  useEffect(() => {
    setBillSummary(calculateBillSummary());
  }, [cart, subTArray, adjustmentType, adjustmentValue]);

  useEffect(() => {
    if (!autoadjustflg) return; // false → leave input blank for manual entry

    const baseTotal = billSummary.baseTotal || 0;

    if (cart.length === 0 || baseTotal === 0) {
      setAdjustmentType("deduct");
      setAdjustmentValue("");
      return;
    }

    // fractional part, rounded to 2 decimals to kill float noise (327.30 → 0.30)
    const fractional = Number((baseTotal - Math.floor(baseTotal)).toFixed(2));

    if (fractional === 0) {
      setAdjustmentType("deduct");
      setAdjustmentValue("0.00");
    } else if (fractional < 0.5) {
      // round down → deduct the fraction (327.30 → deduct 0.30 → 327.00)
      setAdjustmentType("deduct");
      setAdjustmentValue(fractional.toFixed(2));
    } else {
      // round up → add the remainder (327.70 → add 0.30 → 328.00)
      setAdjustmentType("add");
      setAdjustmentValue((1 - fractional).toFixed(2));
    }
  }, [billSummary.baseTotal, autoadjustflg, cart.length]);

  function deepEqual(obj1, obj2) {
    if (obj1 === obj2) {
      return true;
    }

    if (
      typeof obj1 !== "object" ||
      obj1 === null ||
      typeof obj2 !== "object" ||
      obj2 === null
    ) {
      return false;
    }

    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);

    if (keys1.length !== keys2.length) {
      return false;
    }

    for (const key of keys1) {
      if (!keys2.includes(key) || !deepEqual(obj1[key], obj2[key])) {
        return false;
      }
    }

    return true;
  }

  /**************************** tax & disc management ****************************/

  // Update this useEffect to handle cart calculations properly:
  useEffect(() => {
    const updatedCart = cart.map((item, index) => ({
      ...item,
      discount: item.discount || 0,
      discountPercentage: item.discountPercentage || 0,
      amount: calculateAmount(item, selectedUnits[index]),
      taxAmount: calculateTax(item, item.selectedUnit, index),
      subT: subTArray[index] || 0,
    }));

    // Only update if there are actual changes
    if (!deepEqual(updatedCart, cart)) {
      dispatch(setCart(updatedCart));
    }
  }, [cart, subTArray, dispatch, selectedUnits]);

  const handleDiscountChange = (index, type, value) => {
    const updatedCart = cart.map((item, idx) => {
      if (idx === index) {
        let updatedItem = { ...item };

        if (value && value != "0") {
          value = value.startsWith("0") ? value.slice(1) : value;
        }

        if (value == "" || value == null || isNaN(value)) {
          value = "0";
        }

        if (type == "percentage") {
          updatedItem.discountPercentage = value;
          updatedItem.discount = calculateDiscount(updatedItem, selectedUnits[index]);
        } else if (type == "amount") {
          updatedItem.discount = value;
          updatedItem.discountPercentage = calculateDiscountPercentage(
            updatedItem,
            selectedUnits[index]
          );
        }
        updatedItem.amount = calculateAmount(updatedItem, selectedUnits[index]);
        return updatedItem;
      }
      return item;
    });

    dispatch(setCart(updatedCart));
  };

  const calculateDiscount = (row, selectedUnit) => {
    const subtotal = calculateSubT(row, selectedUnit);
    return (
      ((subtotal * parseFloat(row.discountPercentage)) / 100).toFixed(2) || 0
    );
  };

  const calculateDiscountPercentage = (row, selectedUnits) => {
    const subtotal = calculateSubT(row, selectedUnits);

    if (subtotal === 0) {
      return 0;
    }

    return ((parseFloat(row.discount) * 100) / subtotal).toFixed(2) || 0;
  };

  const calculateAmount = (item, selectedunit) => {
    const subtotal = calculateSubT(item, selectedunit);
    const discount = calculateDiscount(item, selectedunit);
    const validDiscount = !isNaN(discount) ? discount : 0;
    const tax = (subtotal * item.taxPercentage) / 100;
    const discountedSubtotal = subtotal - validDiscount;
    const total = discountedSubtotal + tax;

    return !isNaN(total) ? total.toFixed(2) : "0.00";
  };

  // ✅ NEW: Force customer details ON when no default contact exists
  useEffect(() => {
    const hasDefaultContact = !!userdetails?.default_con_for_pos;
    if (!hasDefaultContact && !addCustomerDetails) {
      dispatch(setAddCustomerDetails(true));
      // toast.info("Contact selection is required. Please select a contact.", {
      //   position: "top-right",
      //   autoClose: 3000,
      // });
    }
  }, [addCustomerDetails, userdetails?.default_con_for_pos, dispatch]);

  const Insertinvoicedata = async (data) => {
    dispatch(setSaveBtn(true));
    // ✅ NEW: Check if default contact is NOT configured AND no contact is selected
    const hasDefaultContact = !!userdetails?.default_con_for_pos;
    const hasSelectedContact = !!contact_id;

    // if (!hasDefaultContact && !hasSelectedContact) {
    //   toast.error(
    //     <div>
    //       <div style={{ fontWeight: "bold", marginBottom: "6px" }}>
    //         ⚠️ Contact Required
    //       </div>
    //       <div style={{ fontSize: "12px", lineHeight: "1.5" }}>
    //         No default POS contact is configured.<br />
    //         <strong>Quick Fix:</strong> Select a contact manually, or configure default at:<br />
    //         <em>Setup Home → Contact Setup → Config. Settings → Default POS Contact</em>
    //       </div>
    //     </div>,
    //     {
    //       position: "top-right",
    //       autoClose: 10000,
    //       hideProgressBar: false,
    //     }
    //   );
    //   dispatch(setSaveBtn(false));
    //   return;
    // }

    if (!hasDefaultContact && !hasSelectedContact) {
      Swal.fire({
        title: "Contact Required",
        html: `
      <div style="text-align: left; font-size: 14px; line-height: 1.6;">
        <p style="margin-bottom: 12px;">
          Please select a contact to save this invoice.
        </p>
        
        <div style="background: #e7f1ff; border-radius: 6px; padding: 12px; border-left: 4px solid #0d6efd;">
          <p style="margin: 0 0 8px 0; font-weight: 600; color: #0d6efd;">
            <i class="fa fa-cog"></i> To set a default contact:
          </p>
          <p style="margin: 0 0 6px 0; font-size: 13px; color: #333;">
            <strong>Navigation:</strong> Setup Home → Contact Setup → Configuration Settings
          </p>
          <p style="margin: 0; font-size: 13px; color: #333;">
            <strong>Setting Name:</strong> <em>"The default contact for the POS (Point of Sale) system needs to be default selected"</em>
          </p>
        </div>
      </div>
    `,
        icon: "warning",
        confirmButtonText: "Got It",
        confirmButtonColor: "#0d6efd",
        showCloseButton: true,
        focusConfirm: false,
        allowOutsideClick: false,
        customClass: {
          popup: 'swal-contact-required',
        }
      });

      dispatch(setSaveBtn(false));
      return;
    }

    if (cart.length === 0) {
      toast.error("Please Select at least One Product.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });

      dispatch(setSaveBtn(false));
      return;
    }

    const invalidProducts = cart.filter((product) => product.quantity <= 0);

    if (invalidProducts.length > 0) {
      dispatch(setShowQtyRed(true));
      const errorMessage = `Quantity should be greater than 0 for the following product(s): ${invalidProducts
        .map((product) => product.name)
        .join(", ")}`;

      toast.error(errorMessage, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });

      dispatch(setSaveBtn(false));
      return;
    }

    try {
      const res = await axios.post(
        baseurl + "/expo_access_api/insertInvoiceData/",
        {
          AUTHORIZEKEY: AUTHORIZE_KEY,
          invoice_amount: billSummary?.actualTotalPrice,
          invoice_discount: billSummary?.totalDiscount,
          invoice_tax: billSummary?.totalTaxes,
          grand_total: billSummary?.overallTotal,
          contact_id: contact_id || defaultPosContact?.id || "",
          biiling_addres_id: Billingaddress_id,
          shipping_addres_id: Shippingaddress_id,
          products: cart,
          company_id: selectedCompany,
          branch_id: selectedBranch,
          ...(!autoadjustflg && {
            adjustment_type: adjustmentType == "add" ? "+" : "-",
            adjustment_amount: parseFloat(adjustmentValue) || 0,
          }),
        }
      );

      // ─── Validate response structure ───────────────────────────────
      if (!res || !res.data || !Array.isArray(res.data) || res.data.length === 0) {
        throw new Error("Invalid response from server. Please try again.");
      }

      const apiResponse = res.data[0];
      const apiStatus = apiResponse?.STATUS;
      const apiMessage = apiResponse?.MSG || "Something went wrong.";

      // ─── Handle ERROR status ───────────────────────────────────────
      if (apiStatus === "ERROR") {
        throw new Error(apiMessage);
      }

      // ─── Handle unexpected status (not SUCCESS) ────────────────────
      if (apiStatus !== "SUCCESS") {
        throw new Error(apiMessage);
      }

      // ─── Handle SUCCESS but missing DATA ────────────────────────────
      if (!apiResponse.DATA) {
        throw new Error("Invoice saved but no invoice number received.");
      }

      // ─── SUCCESS ───────────────────────────────────────────────────
      dispatch(setInvoiceDetails({
        invoiceNo: apiResponse.DATA,
        invoiceFullNo: apiResponse.fullinvoice_no
      }));

      toast.success(`Invoice saved successfully! Invoice: ${apiResponse.fullinvoice_no || ""}`, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });

      dispatch(setShowQtyRed(false));
      dispatch(setSaveBtn(true));
      dispatch(setPrintBtn(false));
      dispatch(setWhatsappBtn(false));
      dispatch(setIsInvoiceSaved(true));

    } catch (error) {
      console.error("Error submitting form:", error);

      const userMsg =
        error?.response?.data?.[0]?.MSG ||
        error?.message ||
        "Failed to save invoice. Please try again.";

      toast.error(userMsg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });

      dispatch(setSaveBtn(false));
      dispatch(setShowQtyRed(false));
      dispatch(setPrintBtn(false));
      dispatch(setWhatsappBtn(false));
    }
  };

  const fetchProductsForMainCategory = async (item, index) => {
    setIsSelected(index);
    setProductinfo("Data Found");
    setDisplayFilteredItems([]);
    if (item?.Children?.length > 0) {
      setCategoryData(item?.Children);
      setCategoryinfo("Data Found");
    } else {
      setCategoryinfo("Data Not Found");
      setCategoryData([]);
    }

    try {
      const response = await axios.post(
        "/ecommerce_api/getCategorywiseProductList/",
        {
          category_name: item?.name,
        }
      );

      if (response.data[0].STATUS == "SUCCESS") {
        const data = response.data[0]?.DATA;
        const fetchedItems = data ? data.products : [];
        setCategoryProducts(fetchedItems);
        setDisplayFilteredItems(fetchedItems);
        setProductinfo("Data Found");
        setIsSelected(index);
      } else {
        console.error("Error fetching data:", response.data[0].MSG);
        setAllProducts([]);
        setCategoryProducts([]);
        setDisplayFilteredItems([]);
        setProductinfo("Data Not Found");
        setIsSelected(index);
      }
    } catch (error) {
      console.error("Error in getCategorywiseProductList API:", error);
      setCategoryProducts([]);
      setDisplayFilteredItems([]);
      setProductinfo("Data Not Found");
    } finally {
      setLoading(false);
    }
  };

  const handleClickAll = async () => {
    if (isInvoiceSaved) {
      toast.error("Invoice already saved. You can print this invoice or share it on WhatsApp. To create a new invoice, click 'New'.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      return;
    }

    try {
      await fetchSubcategoriesforAllbutton();
      await fetchAllProductsforAllbutton();
    } catch (error) {
      console.error("Error in handleClickAll:", error);
    }
  };

  const handleBranchChange = (newBranchId) => {
    if (newBranchId === selectedBranch) return;

    // Clear the error highlight as soon as a branch is picked
    if (newBranchId) setBranchError(false);

    if (cart.length === 0) {
      dispatch(setSelectedBranch(newBranchId));
      return;
    }

    const newBranchName =
      branch_arr.find((b) => String(b.branch_id) === String(newBranchId))?.name ||
      "the selected branch";

    Swal.fire({
      title: "Change Branch?",
      html: `
      <div style="text-align: left; font-size: 14px;">
        <p>You are about to switch to <strong>${newBranchName}</strong>.</p>
        <p>Stock is branch-specific, so all items currently in the
cart will be <strong>removed</strong>.</p>
        <p style="font-size: 12px; color: #999; margin-top: 8px;">
          This action cannot be undone.
        </p>
      </div>
    `,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, change branch",
      cancelButtonText: "Cancel",
      reverseButtons: true,
      focusCancel: true,
    }).then((result) => {
      if (result.isConfirmed) {
        // Clear product line
        dispatch(clearCartAction());
        dispatch(setSubTArray([]));
        dispatch(setSelectedUnits({}));

        // Switch branch
        dispatch(setSelectedBranch(newBranchId));
        setCartinfo("Data not found");
      }
      // On cancel: do nothing. The select stays on the old branch
      // because it's controlled by `value={selectedBranch}`.
    });
  };

  const fetchSubcategoriesforAllbutton = async () => {
    setCategoryData([]);
    setCategoryinfo("Data found");
    try {
      const response = await axios.post(
        "/ecommerce_api/getProductCategoryList/",
        {
          tree: false,
          AUTHORIZEKEY: AUTHORIZE_KEY,
          PHPTOKEN: localStorage.getItem("id_token"),
        }
      );

      if (response.data[0].STATUS === "SUCCESS") {
        setCategoryData(response.data[0].DATA.categorylist);
        setCategoryinfo("Data found");
      } else {
        setCategoryData([]);
        setCategoryinfo("Data not found");
      }
    } catch (error) {
      console.error("Error in getProductCategoryList API:", error);
    }
  };

  const fetchAllProductsforAllbutton = async () => {
    setProductinfo("Data Found");
    setDisplayFilteredItems([]);
    try {
      const response = await axios.post(
        "/ecommerce_api/getCategorywiseProductList/",
        {
          category_name: "ALL",
        }
      );

      if (response.data[0].STATUS === "SUCCESS") {
        const data = response.data[0]?.DATA;
        const filteredItems = data ? data.products : [];

        if (filteredItems && filteredItems.length > 0) {
          setAllProducts(filteredItems);
          setCategoryProducts(filteredItems);
          setDisplayFilteredItems(filteredItems);
          setProductinfo("Data Found");
        } else {
          setProductinfo("Data not Found");
          setAllProducts([]);
          setCategoryProducts([]);
          setDisplayFilteredItems([]);
        }
      } else {
        console.error("Error fetching data:", response.data[0].MSG);
      }
    } catch (error) {
      console.error("Error in getCategorywiseProductList API:", error);
      setCategoryProducts([]);
      setDisplayFilteredItems([]);
      setProductinfo("Data Not Found");
    } finally {
      setLoading(false);
    }
  };

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    onBeforeGetContent: () => {
      const element = componentRef.current;
      if (element) {
        element.style.visibility = "visible";
        element.style.position = "relative";
        element.style.left = "0";
        element.style.marginTop = "20px";
      }
      return Promise.resolve();
    },
    onAfterPrint: () => {
      const element = componentRef.current;
      if (element) {
        element.style.visibility = "hidden";
        element.style.position = "absolute";
        element.style.left = "-9999px";
      }
      dispatch(setPrintBtn(false));
    },
  });

  const currenttodaydate = moment().format("DD-MM-YYYY");
  const [showgeneratetext, setShowgeneratetext] = useState(false);

  // Add beforeunload warning
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (cart.length > 0 && !isInvoiceSaved) {
        e.preventDefault();
        e.returnValue = 'You have unsaved items in your cart. Are you sure you want to leave?';
        return e.returnValue;
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [cart.length, isInvoiceSaved]);

  return (
    <>
      {/* ✅ SETUP WARNING BANNER - when no default contact configured */}
      {/* {!userdetails?.default_con_for_pos && (
        <div
          style={{
            backgroundColor: "#fff3cd",
            border: "1px solid #ffc107",
            color: "#856404",
            padding: "10px 16px",
            borderRadius: "6px",
            margin: "10px 16px 0 16px",
            display: "flex",
            alignItems: "center",
            gap: "10px",
            fontSize: "13px",
          }}
        >
          <i className="fa fa-exclamation-triangle" style={{ color: "#ffc107", fontSize: "16px" }}></i>
          <span>
            <strong>No default contact configured for POS.</strong>{" "}
            Please set it up at:{" "}
            <strong>Setup Home → Contact Setup → Config. Settings → Default POS Contact</strong>
            {" "}or select a contact manually below.
          </span>
        </div>
      )} */}
      <div className="mx-2">
        {/* navbar start */}
        {MaincategoryData.length > 0 && (
          <nav className="navbar-pos">
            <ul className="navbar-nav-pos">
              <li
                className={`dropdown-item-pos ${selectedMaincategory == "ALL" ? "selected-item" : ""
                  }`}
                key="all"
                onClick={() => {
                  if (isInvoiceSaved) {
                    toast.error("Invoice already saved. You can print this invoice or share it on WhatsApp. To create a new invoice, click 'New'.", {
                      position: "top-right",
                      autoClose: 5000,
                      hideProgressBar: false,
                      closeOnClick: true,
                      pauseOnHover: true,
                      draggable: true,
                    });
                    return;
                  }
                  dispatch(setSelectedMaincategory("ALL"));
                  handleClickAll();
                }}
              >
                ALL
              </li>
              {MaincategoryData.slice(0, 7).map((item, index) => {
                return (
                  <li
                    key={`maincat-${item.ID}`}
                    className={`dropdown-item-pos ${selectedMaincategory == item?.name ? "selected-item" : ""
                      }`}
                    onClick={() => {
                      if (isInvoiceSaved) {
                        toast.error("Invoice already saved. You can print this invoice or share it on WhatsApp. To create a new invoice, click 'New'.", {
                          position: "top-right",
                          autoClose: 5000,
                          hideProgressBar: false,
                          closeOnClick: true,
                          pauseOnHover: true,
                          draggable: true,
                        });
                        return;
                      }
                      dispatch(setSelectedMaincategory(item?.name));
                      fetchProductsForMainCategory(item, index);
                    }}
                  >
                    {item?.name}
                  </li>
                );
              })}
              {MaincategoryData.length > 7 && (
                <li
                  key="more"
                  className={`nav-item dropdown-more dropdown-item-pos ${selectedMaincategory == "More" ? "selected-item" : ""
                    }`}
                  onClick={() => {
                    if (isInvoiceSaved) {
                      toast.error("Invoice already saved. You can print this invoice or share it on WhatsApp. To create a new invoice, click 'New'.", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                      });
                      return;
                    }
                    handleMoreClick();
                  }}
                >
                  <button className="dropdown-toggle">More</button>
                  {showMore && (
                    <div className="dropdown-content">
                      <ul>
                        {MaincategoryData.slice(7).map((item, index) => (
                          <React.Fragment key={index}>
                            <li
                              key={`moreitem-${item.ID}`}
                              onClick={() => {
                                if (isInvoiceSaved) {
                                  toast.error("Invoice already saved. You can print this invoice or share it on WhatsApp. To create a new invoice, click 'New'.", {
                                    position: "top-right",
                                    autoClose: 5000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                  });
                                  return;
                                }
                                fetchProductsForMainCategory(item, index);
                              }}
                            >
                              {item.name}
                            </li>
                            {index < MaincategoryData.slice(7).length - 1 && (
                              <hr className="more-horizontal" />
                            )}
                          </React.Fragment>
                        ))}
                      </ul>
                    </div>
                  )}
                </li>
              )}
            </ul>
          </nav>
        )}

        {/* navbar end  */}
        <Row className="my-grid mt-2">
          <Col
            className={`${categoriesToDisplay.length < 12
              ? " vertical-line"
              : "overflow-y-auto custom-scrollbar"
              }`}
          >
            <Form className="mt-1">
              <FormGroup
                className="m-0 form-group"
              >
                <div className="productSearchInputGroup">
                  <Input
                    className="form-control"
                    type="text"
                    placeholder="search categories..."
                    value={categorySearchQuery}
                    onChange={handleCategorySearchChange}
                    disabled={isInvoiceSaved}
                    style={{ cursor: isInvoiceSaved ? 'not-allowed' : 'text', opacity: isInvoiceSaved ? 0.75 : 1 }}
                  />
                </div>
              </FormGroup>
            </Form>
            <div className="d-flex flex-column mt-2 ">
              <div>
                {category_info == "Data Not Found" &&
                  categoriesToDisplay.length == 0 ? (
                  <div className="center-nocategory vertical-line">
                    No categories found
                  </div>
                ) : null}
                {categoriesToDisplay && categoriesToDisplay.length > 0
                  ? categoriesToDisplay.map((item) => (
                    <div
                      id="cat-gridId"
                      className={`cat-gridId ${selectedCategory == item.name ? "selected" : ""
                        } d-flex-row hoverable`}
                      key={item.ID}
                      onClick={() => {
                        if (isInvoiceSaved) {
                          toast.error("Invoice already saved. You can print this invoice or share it on WhatsApp. To create a new invoice, click 'New'.", {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                          });
                          return;
                        }
                        handleCategoryClick(item.name);
                      }}
                    >
                      <img
                        src={
                          item.full_image_path
                            ? item.full_image_path
                            : "https://r1services.ondemandcrm.co/public/images/ecommerce/productnotfound.png"
                        }
                        alt={item.name}
                        className="cat-img"
                        style={{ marginLeft: "2px" }}
                      />
                      <div className="categoryItemContainer">
                        <p
                          className={`category-name ${selectedCategory === item.name ? "selected" : ""
                            } `}
                        >
                          {item.name}
                        </p>
                      </div>
                    </div>
                  ))
                  : null}
                {category_info != "Data Not Found" &&
                  categoriesToDisplay.length == 0 && (
                    <div className="text-center mt-3">
                      <Spinner animation="border" variant="success" />
                    </div>
                  )}
              </div>
            </div>

            {/* <div className="d-flex flex-column mt-2">
              <div>
                {category_info == "Data Not Found" && categoriesToDisplay.length == 0 ? (
                  <div className="center-nocategory vertical-line">
                    No categories found
                  </div>
                ) : null}

                {categoriesToDisplay && categoriesToDisplay.length > 0
                  ? categoriesToDisplay.map((item) => (
                    <div
                      id="cat-gridId"
                      className={`cat-gridId ${selectedCategory == item.name ? "selected" : ""} d-flex-row hoverable`}
                      key={item.ID}
                      onClick={() => {
                        if (isInvoiceSaved) {
                          toast.error("Invoice already saved. You can print this invoice or share it on WhatsApp. To create a new invoice, click 'New'.", {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                          });
                          return;
                        }
                        handleCategoryClick(item.name);
                      }}
                    >
                      <div
                        style={{
                          width: "40px",
                          height: "40px",
                          minWidth: "40px",
                          minHeight: "40px",
                          borderRadius: "8px",
                          overflow: "hidden",
                          backgroundColor: "#f8f9fa",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          marginRight: "10px",
                        }}
                      >
                        <img
                          src={
                            item.full_image_path
                              ? item.full_image_path
                              : "https://r1services.ondemandcrm.co/public/images/ecommerce/productnotfound.png"
                          }
                          alt={item.name}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </div>
                      <div className="categoryItemContainer">
                        <p
                          className={`category-name ${selectedCategory === item.name ? "selected" : ""}`}
                          style={{
                            margin: 0,
                            fontSize: "14px",
                            fontWeight: "500",
                            lineHeight: "1.3",
                            wordBreak: "break-word",
                          }}
                        >
                          {item.name}
                        </p>
                      </div>
                    </div>
                  ))
                  : null}

                {category_info != "Data Not Found" && categoriesToDisplay.length == 0 && (
                  <div className="text-center mt-3">
                    <Spinner animation="border" variant="success" />
                  </div>
                )}
              </div>
            </div> */}
          </Col>

          {/* Product display */}
          <Col
            className={`${displayFilteredItems.length > 12
              ? " overflow-y-auto custom-scrollbar "
              : "vertical-line"
              }`}
          >
            <div className=" d-flex-col">
              <Form className="mt-1">
                <FormGroup
                  className="m-0 form-group search-product"
                >
                  <div className="productSearchInputGroup">
                    <Input
                      className="form-control"
                      type="text"
                      placeholder="search products..."
                      value={searchQuery}
                      onChange={(e) => {
                        dispatch(setSearchQuery(e.target.value));
                      }}
                      disabled={isInvoiceSaved}
                      style={{ cursor: isInvoiceSaved ? 'not-allowed' : 'text', opacity: isInvoiceSaved ? 0.75 : 1 }}
                    />

                    <i
                      className="fa fa-search"
                      onClick={() => {
                        if (isInvoiceSaved) {
                          toast.error("Invoice already saved. You can print this invoice or share it on WhatsApp. To create a new invoice, click 'New'.", {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                          });
                          return;
                        }
                      }}
                    ></i>
                  </div>
                </FormGroup>
              </Form>
              {/* ✅ MOVED OUTSIDE: No products found */}
              {product_info == "Data Not Found" &&
                displayFilteredItems.length == 0 ? (
                <div
                  className="loaderContainer d-flex-col vertical-line justify-content-center align-items-center"
                  style={{ minHeight: "70vh" }}
                >
                  No products found
                </div>
              ) : null}

              {/* ✅ MOVED OUTSIDE: Loading spinner */}
              {product_info != "Data Not Found" &&
                displayFilteredItems.length == 0 ? (
                <div className="loaderContainer d-flex-col vertical-line justify-content-center align-items-center" style={{ minHeight: "70vh" }}>
                  <Spinner animation="border" variant="success" />
                </div>
              ) : null}

              {/* Product grid - only renders when there are items */}
              {displayFilteredItems && displayFilteredItems.length > 0 ? (
                <div className="productItemsContainer mt-2">
                  {displayFilteredItems.map((item, index) => (
                    <div
                      id="prod-gridId"
                      className="product-img d-flex-col center hoverable"
                      key={item.product_id}
                      onClick={() => {
                        if (isInvoiceSaved) {
                          toast.error(
                            "Invoice already saved. You can print this invoice or share it on WhatsApp. To create a new invoice, click 'New'.",
                            { position: "top-right", autoClose: 5000 }
                          );
                          return;
                        }
                        Openatrributemodal(item, item.product_id, item?.name, index);
                      }}
                    >
                      <div className="product-img-wrapper">
                        <Image
                          attrImage={{
                            className: "img-fluid prod-img",
                            src: item?.original_photo_path
                              ? item.original_photo_path
                              : "https://r1services.ondemandcrm.co/public/images/ecommerce/productnotfound.png",
                            alt: item?.name || "",
                            loading: "lazy",
                            onError: (e) => {
                              e.target.onerror = null;
                              e.target.src =
                                "https://r1services.ondemandcrm.co/public/images/ecommerce/productnotfound.png";
                            },
                          }}
                        />
                      </div>
                      <p className="product-name">{item.name}</p>
                    </div>
                  ))}
                </div>
              ) : null}
            </div>
          </Col>

          {/* Product qty portion discount portion */}
          <Col>
            <div className="d-flex-col">
              <div className="rightMenu d-flex-col">
                <Row>
                  <Col md={4}>
                    <div className="shippingCheckboxContainer d-flex-row invisible">
                      {addCustomerDetails && showBillingModal && (
                        <>
                          <label htmlFor="shippingCheckbox">
                            Shipping Same as Billing
                          </label>
                          <input
                            type="checkbox"
                            id="shippingCheckbox"
                            name="shippingCheckbox"
                            checked={sameAsBilling}  // Use local state instead of Redux state
                            onChange={handleCheckboxChange}
                            disabled={isInvoiceSaved}
                            style={{ cursor: isInvoiceSaved ? 'not-allowed' : 'pointer', opacity: isInvoiceSaved ? 0.75 : 1 }}
                          />
                        </>
                      )}
                    </div>
                  </Col>
                  <Col md={4}>
                    <div className="shippingCheckboxContainer d-flex-row">
                      {addCustomerDetails && showBillingModal && (
                        <>
                          <label htmlFor="shippingCheckbox">
                            Shipping Same as Billing
                          </label>
                          <input
                            type="checkbox"
                            id="shippingCheckbox"
                            name="shippingCheckbox"
                            checked={sameAsBilling}  // Use local state instead of Redux state
                            onChange={handleCheckboxChange}
                            disabled={isInvoiceSaved}
                            style={{ cursor: isInvoiceSaved ? 'not-allowed' : 'pointer', opacity: isInvoiceSaved ? 0.75 : 1 }}
                          />
                        </>
                      )}
                    </div>
                  </Col>
                  <Col md={4} className="customerdetail-switch mt-1">
                    {/* In your JSX where the toggle is */}
                    <div
                      className="form-check form-switch cust-toggle-line d-flex-row"
                      style={{
                        cursor: !userdetails?.default_con_for_pos ? 'not-allowed' : (isInvoiceSaved ? 'not-allowed' : 'pointer'),
                        pointerEvents: 'auto',  // ✅ wrapper handles pointer
                        opacity: (!userdetails?.default_con_for_pos || isInvoiceSaved) ? 0.75 : 1,
                      }}
                    >
                      <label className="form-check-label" htmlFor="toggleSwitch" style={{ pointerEvents: 'none' }}>
                        <MdContactPhone className="contact-icon me-1" />
                        Add Customer Details
                        {!userdetails?.default_con_for_pos && (
                          <span style={{ color: "#dc3545", fontSize: "12px", marginLeft: "6px" }}>
                            *
                          </span>
                        )}
                      </label>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        id="toggleSwitch"
                        checked={addCustomerDetails}
                        onChange={() => {
                          if (addCustomerDetails && !userdetails?.default_con_for_pos) {
                            toast.warning("Contact is mandatory. Please select a contact.", {
                              position: "top-right",
                              autoClose: 3000,
                            });
                            return;
                          }
                          dispatch(setAddCustomerDetails(!addCustomerDetails));
                        }}
                        disabled={isInvoiceSaved}
                        style={{
                          cursor: !userdetails?.default_con_for_pos ? 'not-allowed' : (isInvoiceSaved ? 'not-allowed' : 'pointer'),
                          // pointerEvents: 'none',  // ✅ disabled but cursor shows via wrapper
                        }}
                      />
                    </div>
                  </Col>
                </Row>

                {addCustomerDetails && (
                  <>
                    <Row>
                      <Col md={4}>
                        <Row>
                          <Col md={10} style={{ paddingRight: "0px" }}>
                            <div className="d-flex-col">
                              <ReactSelect
                                options={contacts
                                  .filter((contact) => contact.name)
                                  .map((contact) => ({
                                    value: contact.id,
                                    label: `${contact.name} - ${contact.mobile}`,
                                    email: contact.email,
                                    mobile: contact.mobile,
                                    contactname: contact.name,
                                  }))}
                                components={animatedComponents}
                                menuPortalTarget={document.body}
                                isClearable={true}                          // ✅ ADD: enables × clear button
                                placeholder={
                                  !userdetails?.default_con_for_pos          // ✅ ADD: show * in placeholder when mandatory
                                    ? "Select Contact *"
                                    : "Select Contact..."
                                }
                                value={
                                  selectedContact
                                    ? {
                                      value: selectedContact.id,
                                      label: `${selectedContact.name} - ${selectedContact.mobile}`,
                                    }
                                    : null
                                }
                                onChange={(selectedOption) => {
                                  // ✅ ADD: handle clear (selectedOption is null when cleared)
                                  if (!selectedOption) {
                                    dispatch(setContactDetails({
                                      id: "",
                                      name: "",
                                      number: ""
                                    }));
                                    setAddress([]); // clear addresses too
                                    return;
                                  }
                                  handleSelectChange(selectedOption);
                                }}
                                isDisabled={isInvoiceSaved}
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    cursor: isInvoiceSaved ? 'not-allowed' : 'pointer',
                                    opacity: isInvoiceSaved ? 0.75 : 1,
                                    // ✅ ADD: red border when mandatory and no contact selected
                                    ...(!userdetails?.default_con_for_pos && !contact_id && {
                                      borderColor: "#dc3545",
                                      boxShadow: "0 0 0 0.15rem rgba(220,53,69,.25)",
                                    }),
                                  }),
                                  menu: (base) => ({
                                    ...base,
                                    cursor: isInvoiceSaved ? 'not-allowed' : 'pointer',
                                    opacity: isInvoiceSaved ? 0.75 : 1,
                                  }),
                                  placeholder: (base) => ({                    // ✅ ADD: red placeholder text
                                    ...base,
                                    ...(!userdetails?.default_con_for_pos && !contact_id && {
                                      color: "#dc3545",
                                    }),
                                  }),
                                }}
                              />

                              <div className="d-flex contact-group mt-1">
                                <p className="contact-p">
                                  Contact
                                  {!userdetails?.default_con_for_pos && (    // ✅ ADD: red * indicator
                                    <span style={{ color: "#dc3545", fontWeight: "bold", marginLeft: "3px" }}>
                                      *
                                    </span>
                                  )}
                                </p>
                              </div>
                            </div>
                          </Col>
                          <Col md={2}>
                            <Button
                              variant="primary"
                              className="searchbtn mt-2 p-1 btn-sm d-flex align-items-center contact-button"
                              onClick={togglecontact}
                              disabled={isInvoiceSaved}
                              style={{ cursor: isInvoiceSaved ? 'not-allowed' : 'pointer', opacity: isInvoiceSaved ? 0.75 : 1 }}
                            >
                              <AiOutlinePlus size={15} />
                            </Button>
                          </Col>
                        </Row>
                      </Col>

                      <Col md={4}>
                        {showBillingModal && (
                          <>
                            <Row>
                              <Col md={10} style={{ paddingRight: "0px" }}>
                                <div className="d-flex-col">
                                  <select
                                    className="form-select form-control form-control-sm"
                                    id="sel_address"
                                    name="sel_address"
                                    value={Billingaddress_id || ""}
                                    onChange={(e) =>
                                      dispatch(setAddressDetails({
                                        billingAddressId: e.target.value,
                                        // ✅ KEY FIX: if sameAsBilling, shipping always follows billing
                                        shippingAddressId: sameAsBilling ? e.target.value : Shippingaddress_id,
                                        sameAsBilling,
                                      }))
                                    }
                                    disabled={isInvoiceSaved}
                                    style={{ cursor: isInvoiceSaved ? 'not-allowed' : 'pointer', opacity: isInvoiceSaved ? 0.75 : 1 }}
                                  >
                                    <option value="">-- Select Billing Address --</option>
                                    {Address.map((option) => (
                                      <option key={option.address_id} value={option.address_id}>
                                        {option.address_1 ? option.address_1.slice(0, 25) : "No Address found"}
                                      </option>
                                    ))}
                                  </select>

                                  <div className="d-flex billing-group mt-1">
                                    <p className="billing-p">Billing address</p>
                                  </div>
                                </div>
                              </Col>
                              <Col md={2}>
                                <div>
                                  <Button
                                    variant="primary"
                                    className="searchbtn mt-2 p-1 btn-sm d-flex align-items-center billing-button"
                                    onClick={togglebilling}
                                    disabled={isInvoiceSaved}
                                    style={{ cursor: isInvoiceSaved ? 'not-allowed' : 'pointer', opacity: isInvoiceSaved ? 0.75 : 1 }}
                                  >
                                    <AiOutlinePlus size={15} />
                                  </Button>
                                </div>
                              </Col>
                            </Row>
                          </>
                        )}
                      </Col>

                      <Col md={4}>
                        {showShippingModal && (
                          <>
                            <Row>
                              <Col md={10} style={{ paddingRight: "0px" }}>
                                <div className="d-flex-col">
                                  <Form.Select
                                    aria-label="Second select example"
                                    value={Shippingaddress_id || ""}
                                    onChange={(e) =>
                                      dispatch(setAddressDetails({
                                        billingAddressId: Billingaddress_id,
                                        shippingAddressId: e.target.value,
                                        sameAsBilling,
                                      }))
                                    }
                                    disabled={isInvoiceSaved}
                                    style={{ cursor: isInvoiceSaved ? 'not-allowed' : 'pointer', opacity: isInvoiceSaved ? 0.75 : 1 }}
                                  >
                                    {Address.map((option) => (
                                      <option
                                        key={option.address_id}
                                        value={option.address_id}
                                      >
                                        {option.address_1
                                          ? option.address_1.slice(0, 25)
                                          : "No Address found"}
                                      </option>
                                    ))}
                                  </Form.Select>
                                  <div className="shipping-group d-flex-row mt-1">
                                    <p className="shipping-p">
                                      Shipping address
                                    </p>
                                  </div>
                                </div>
                              </Col>
                              <Col md={2} style={{ paddingRight: "0px" }}>
                                <div>
                                </div>
                              </Col>
                            </Row>
                          </>
                        )}
                      </Col>
                    </Row>
                  </>
                )}

                <Row>
                  <Col md={4}>
                    <Row>
                      <Col md={10} style={{ paddingRight: "0px" }}>
                        <div className="d-flex-col">
                          <Form.Select
                            aria-label="Second select example"
                            value={selectedCompany}
                            className="select-company"
                            onChange={(e) => dispatch(setSelectedCompany(e.target.value))}
                            disabled={isInvoiceSaved}
                            style={{ cursor: isInvoiceSaved ? 'not-allowed' : 'pointer', opacity: isInvoiceSaved ? 0.75 : 1 }}
                          >
                            {Array.isArray(company_arr) &&
                              company_arr.length > 0 &&
                              company_arr?.map((cr, j) => (
                                <option value={cr.company_id} key={j}>
                                  {cr.name}{" "}
                                </option>
                              ))}
                          </Form.Select>
                          <div className="shipping-group d-flex-row mt-1">
                            <p className="shipping-p">Company</p>
                          </div>
                        </div>
                      </Col>
                      <Col md={2} style={{ paddingRight: "0px" }}>
                        <div>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                  <Col md={4}>
                    <Row>
                      <Col md={10} style={{ paddingRight: "0px" }}>
                        <div className="d-flex-col">
                          <Form.Select
                            aria-label="Second select example"
                            value={selectedBranch || ""}
                            onChange={(e) => handleBranchChange(e.target.value)}
                            disabled={isInvoiceSaved}
                            className={branchError ? "is-invalid branch-error" : ""}
                            style={{
                              cursor: isInvoiceSaved ? 'not-allowed' : 'pointer',
                              opacity: isInvoiceSaved ? 0.75 : 1,
                              ...(branchError
                                ? { borderColor: "#dc3545", boxShadow: "0 0 0 0.15rem rgba(220,53,69,.25)" }
                                : {}),
                            }}
                          >
                            {/* ✅ Only show placeholder when 0 or 2+ branches */}
                            {branch_arr?.length !== 1 && (
                              <option value="">-- Select Branch --</option>
                            )}
                            {Array.isArray(branch_arr) &&
                              branch_arr.length > 0 &&
                              branch_arr?.map((br, i) => (
                                <option value={br.branch_id} key={i}>
                                  {br.name}{" "}
                                </option>
                              ))}
                          </Form.Select>
                          <div className="shipping-group d-flex-row mt-1">
                            <p className="shipping-p">Branch</p>
                          </div>
                        </div>
                      </Col>
                      <Col md={2} style={{ paddingRight: "0px" }}>
                        <div>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col md={4}>
                    <Form className="mt-1">
                      <FormGroup
                        className="m-0 form-group search-product"
                      >
                        <div className="productSearchInputGroup barcode-input">
                          <Input
                            className="form-control"
                            type="text"
                            placeholder="search barcode..."
                            value={searchBarcode}
                            onChange={(e) => {
                              dispatch(setSearchBarcode(e.target.value));
                            }}
                            disabled={isInvoiceSaved}
                            style={{ cursor: isInvoiceSaved ? 'not-allowed' : 'text', opacity: isInvoiceSaved ? 0.75 : 1 }}
                          />

                          <i
                            className="fa fa-search"
                            onClick={() => {
                              if (isInvoiceSaved) {
                                toast.error("Invoice already saved. You can print this invoice or share it on WhatsApp. To create a new invoice, click 'New'.", {
                                  position: "top-right",
                                  autoClose: 5000,
                                  hideProgressBar: false,
                                  closeOnClick: true,
                                  pauseOnHover: true,
                                  draggable: true,
                                });
                                return;
                              }
                            }}
                          ></i>
                        </div>
                      </FormGroup>
                    </Form>
                  </Col>
                </Row>

                {/* draft code */}

                <Modal
                  isOpen={isOpen}
                  toggle={() => dispatch(toggleModal())}
                  className="draft-modal-lg"
                  size="xl"
                  backdrop="static"
                  keyboard={false}
                >
                  <ModalHeader toggle={() => dispatch(toggleModal())}>
                    All Draft Orders
                  </ModalHeader>
                  <ModalBody className="">
                    <Row className="gy-3 gx-3">
                      {drafts.length == 0 ? (
                        <p style={{ fontSize: "20px", fontWeight: "bolder" }}>
                          No draft orders available.
                        </p>
                      ) : (
                        drafts.map((draft) => (
                          <Col
                            key={draft.id}
                            md={3}
                            onClick={() => {
                              if (isInvoiceSaved) {
                                Swal.fire({
                                  title: "Invoice Already Saved",
                                  html: `
    <div style="text-align: left; font-size: 14px;">
      <p><strong>This invoice has already been saved.</strong></p>
      <p>You can perform the following actions:</p>
      <ul style="padding-left: 18px;">
        <li>🖨️ Print the invoice</li>
        <li>📲 Share the invoice on WhatsApp</li>
      </ul>
      <p style="margin-top: 10px;">
        To create a new invoice, please click the <strong>"New"</strong> button.
      </p>
    </div>
  `,
                                  icon: "info",
                                  confirmButtonText: "OK",
                                  confirmButtonColor: "#0d6efd",
                                  showCloseButton: true,
                                  focusConfirm: false,
                                });

                                return;
                              }
                              handleEdit(draft, drafts);
                            }}
                            style={{ cursor: isInvoiceSaved ? 'not-allowed' : 'pointer' }}
                          >
                            <div className="draftBox d-flex-col">
                              <p className="draftNumber mb-0">{`Draft #${drafts.indexOf(draft) + 1}`}</p>

                              <p className="draftDetails-p">
                                <span
                                  style={{ fontWeight: "bold", color: "black" }}
                                >{`Contact: `}</span>
                                {`${draft?.contactName && draft?.contactName}`}
                              </p>
                              <p
                                className="draftDetails-p "
                                style={{ fontWeight: "bold", color: "black" }}
                              >
                                {`Date and Time: `}
                              </p>
                              <p className="mb-0">
                                {`${draft?.currentDateAndTime}`}
                              </p>
                              <p className="draftDetails-p">
                                <span
                                  style={{ fontWeight: "bold", color: "black" }}
                                >{`Mobile No: `}</span>
                                {`${draft?.contactMobileNumber &&
                                  draft?.contactMobileNumber
                                  }`}
                              </p>
                              <p className="draftDetails-p">
                                <span style={{ fontWeight: "bold", color: "black" }}>{`Branch: `}</span>
                                <span
                                  style={{
                                    background: draft?.selectedBranchName ? "#e7f1ff" : "#f8d7da",
                                    color: draft?.selectedBranchName ? "#0d6efd" : "#842029",
                                    padding: "1px 6px",
                                    borderRadius: "4px",
                                    fontWeight: "600",
                                  }}
                                >
                                  {draft?.selectedBranchName || "No branch"}
                                </span>
                              </p>
                              <p className="draftDetails-p">
                                <span
                                  style={{ fontWeight: "bold", color: "black" }}
                                >{`Total Products: `}</span>
                                {`${draft?.numberOfItems}`}
                              </p>

                              <p className="draftDetails-p">
                                <span
                                  style={{ fontWeight: "bold", color: "black" }}
                                >{`Total Quantity: `}</span>
                                {`${draft?.TotalQuantity}`}
                              </p>

                              <p className="draftDetails-p draft-total-amt">
                                {`Amount to Pay: `}
                              </p>
                              <p
                                style={{
                                  marginTop: "2px",
                                  fontSize: "large",
                                  fontWeight: "bold",
                                  color: "green",
                                }}
                                className="mb-0"
                              >
                                {`₹${parseFloat(draft.total).toFixed(2)}`}
                              </p>
                              <div className="d-flex justify-content-end">
                                <div>
                                  <Button
                                    className="modal-button"
                                    variant="info"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleEdit(draft, drafts);
                                    }}
                                    disabled={isInvoiceSaved}
                                    style={{ cursor: isInvoiceSaved ? 'not-allowed' : 'pointer', opacity: isInvoiceSaved ? 0.75 : 1 }}
                                  >
                                    <FaEdit />
                                  </Button>
                                </div>
                                <div className="ms-2">
                                  <Button
                                    className="modal-button"
                                    variant="danger"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleDelete(draft, drafts);
                                    }}
                                    disabled={isInvoiceSaved}
                                    style={{ cursor: isInvoiceSaved ? 'not-allowed' : 'pointer', opacity: isInvoiceSaved ? 0.75 : 1 }}
                                  >
                                    <RiDeleteBin7Fill />
                                  </Button>
                                </div>
                              </div>
                            </div>
                          </Col>
                        ))
                      )}
                    </Row>
                  </ModalBody>
                  <ModalFooter>
                    <Button
                      color="secondary"
                      onClick={() => dispatch(toggleModal())}
                    >
                      Close
                    </Button>
                  </ModalFooter>
                </Modal>
              </div>
              <div className="billContainer d-flex-col">
                <div className="billContainerBody d-flex-col">
                  <div className="bill">
                    {cart_info == "Data not found" && cart.length == 0 ? (
                      <div
                        className="text-center mt-3 py-3"
                        style={{ backgroundColor: "#dfdcdc" }}
                      >
                        There are no records to display
                      </div>
                    ) : cart_loading ? (
                      <div className="text-center pt-3 pb-2">
                        <Spinner animation="border" variant="success" />
                      </div>
                    ) : (
                      <DataTable
                        noHeader
                        paginationServer
                        columns={productColumns}
                        data={cart}
                        highlightOnHover={true}
                        striped={true}
                        responsive={true}
                        persistTableHead={true}
                      />
                    )}
                  </div>
                </div>



                <div className="extraDetailsContainer d-flex-col">
                  <div className="resultContainer d-flex-row">
                    <table className="resultTable box">
                      <thead>
                        <tr>
                          <th colSpan="2">Bill Summary</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Total Products:</td>
                          <td>{billSummary.totalItems}</td>
                        </tr>
                        <tr style={{ borderBottom: "1px solid #ddd" }}>
                          <td>Total Gross Amount:</td>
                          <td>₹{billSummary.actualTotalPrice.toFixed(2)}</td>
                        </tr>
                        <tr>
                          <td>Total Discount:</td>
                          <td style={{ color: "#dc3545" }}>
                            − ₹{billSummary.totalDiscount.toFixed(2)}
                          </td>
                        </tr>
                        <tr style={{ borderBottom: "1px solid #ddd" }}>
                          <td>Total Taxes:</td>
                          <td>+ ₹{billSummary.totalTaxes.toFixed(2)}</td>
                        </tr>
                        <tr style={{ borderBottom: "1px solid #ddd" }}>
                          <td>
                            <div style={{ display: "flex", gap: "6px", alignItems: "center" }}>
                              <span>Adjustment:</span>
                              <select
                                value={adjustmentType}
                                onChange={(e) => setAdjustmentType(e.target.value)}
                                disabled={isInvoiceSaved || autoadjustflg}
                                style={{
                                  padding: "2px 4px",
                                  fontSize: "13px",
                                  borderRadius: "4px",
                                  border: "1px solid #ced4da",
                                  cursor:
                                    isInvoiceSaved || autoadjustflg ? "not-allowed" : "pointer",
                                  opacity: isInvoiceSaved || autoadjustflg ? 0.75 : 1,
                                }}
                              >
                                <option value="add">Add</option>
                                <option value="deduct">Deduct</option>
                              </select>
                            </div>
                          </td>
                          <td>
                            <input
                              type="text"
                              inputMode="decimal"
                              value={adjustmentValue}
                              onChange={handleAdjustmentValueChange}
                              placeholder="0.00"
                              disabled={isInvoiceSaved || autoadjustflg}
                              style={{
                                width: "70px",
                                padding: "2px 6px",
                                fontSize: "13px",
                                borderRadius: "4px",
                                border: "1px solid #ced4da",
                                textAlign: "left",
                                cursor:
                                  isInvoiceSaved || autoadjustflg ? "not-allowed" : "text",
                                opacity: isInvoiceSaved || autoadjustflg ? 0.75 : 1,
                              }}
                            />
                          </td>
                        </tr>
                        <tr style={{ borderBottom: "1px solid #ddd" }}>
                          <td>Total Payable Amount:</td>
                          <td
                            style={{
                              fontSize: "larger",
                              color: "green",
                              fontWeight: "500",
                            }}
                          >
                            ₹{billSummary.overallTotal.toFixed(2)}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  {showgeneratetext && (
                    <div className="text-center timesheet-label mt-3">
                      Please wait while sending message...
                    </div>
                  )}

                  {isInvoiceSaved && (
                    <div className="invoice-saved-notification d-flex-col text-center p-3 mt-3">
                      <div className="success-check mb-2">
                        <i className="fa fa-check-circle" style={{ fontSize: "2rem", color: "#28a745" }}></i>
                      </div>
                      <h5 className="text-success mb-2">Invoice Saved Successfully!</h5>
                      <p className="mb-1">
                        <strong>Invoice No:</strong> {Invoice_fullno}
                      </p>
                      <p className="mb-1">You can now print or share it on WhatsApp.</p>
                      <p className="mb-0 small text-muted">
                        To create a new invoice, click the <strong>"New"</strong> button.
                      </p>
                    </div>
                  )}

                  <div className="buttonsBillContainer d-flex-row">
                    <button
                      type="button"
                      className="btn btn-info new-btn buttonBill save d-flex-row"
                      // Update the New button onClick:
                      onClick={() => {
                        dispatch(resetForNewInvoice());

                        // Clear local states
                        setProductselectid("");
                        setAttrlabel([]);
                        setPricelistaarray([]);
                        setAddress([]);
                        setBranchError(false);   // ✅ add this

                        setAdjustmentType("deduct");   // ✅ add
                        setAdjustmentValue("");        // ✅ add

                        // Reset company/branch to defaults
                        if (company_arr?.length > 0) {
                          dispatch(setSelectedCompany(company_arr[0].company_id));
                        }
                        // if (branch_arr?.length > 0) {
                        //   dispatch(setSelectedBranch(branch_arr[0].branch_id));
                        // }
                        dispatch(setSelectedBranch(""));

                        setCartinfo("Data not found");
                      }}
                    >
                      <div className="svgButtonContainer d-flex-row">
                        <MdCreateNewFolder
                          className="bill-button-svg"
                          size={20}
                        />
                      </div>
                      <span className="bill-button-text">New</span>
                    </button>

                    <button
                      type="button"
                      className="draft-button-group btn btn-warning buttonBill draft d-flex-row"
                      // Update the Draft button onClick:
                      // In the Draft button onClick:
                      onClick={() => {
                        if (cart.length > 0) {
                          const total = cart.reduce(
                            (acc, item) => acc + parseFloat(item.amount),
                            0
                          );

                          const totalQuantity = cart.reduce((acc, item) => {
                            return acc + item.quantity;
                          }, 0);

                          const selectedBranchName =
                            branch_arr.find((b) => String(b.branch_id) === String(selectedBranch))?.name || "";

                          const newDraft = {
                            id: Date.now(),
                            items: [...cart],
                            numberOfItems: cart?.length,
                            contactName: addCustomerDetails && contact_name != "" ? contact_name : "",
                            contactMobileNumber: addCustomerDetails && contact_number != "" ? contact_number : "",
                            contactid: addCustomerDetails && contact_id != "" ? contact_id : "",
                            BillingaddressId: Billingaddress_id,
                            ShippingaddressId: Shippingaddress_id,
                            Ship_Bill_Same: sameAsBilling,
                            selectedCompany: selectedCompany,
                            selectedBranch: selectedBranch,
                            selectedBranchName: selectedBranchName,   // ✅ denormalized for display
                            total: total,
                            currentDateAndTime: moment().format("MMMM Do YYYY, h:mm:ss a"),
                            TotalQuantity: totalQuantity,
                          };

                          addDraft(newDraft);

                          // Reset all state
                          dispatch(resetForNewInvoice());

                          // Clear local states
                          setAddress([]);
                          setProductselectid("");
                          setAttrlabel([]);
                          setPricelistaarray([]);
                          setCartinfo("Data not found");
                        } else {
                          toast.error("Please Select Product", {
                            position: "top-right",
                            autoClose: 2000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored",
                          });
                        }
                      }}
                      disabled={Savebtn}
                      style={{ cursor: Savebtn ? 'not-allowed' : 'pointer', opacity: Savebtn ? 0.75 : 1 }}
                    >
                      <div className="svgButtonContainer d-flex-row">
                        <MdDrafts className="bill-button-svg" size={20} />
                      </div>
                      <span className="bill-button-text">Draft</span>
                    </button>

                    <button
                      type="button"
                      className="save-button-group btn btn-success buttonBill save d-flex-row"
                      onClick={() => Insertinvoicedata()}
                      disabled={Savebtn} // ✅ disable save
                    // style={{
                    //   cursor: Savebtn || (!userdetails?.default_con_for_pos && !contact_id) ? 'not-allowed' : 'pointer',
                    //   opacity: Savebtn || (!userdetails?.default_con_for_pos && !contact_id) ? 0.75 : 1
                    // }}
                    >
                      <div className="svgButtonContainer d-flex-row">
                        <FaSave className="bill-button-svg" size={20} />
                      </div>
                      <span className="bill-button-text">Save</span>
                    </button>

                    <button
                      type="button"
                      className="print-button-group btn btn-gradient buttonBill save d-flex-row"
                      onClick={() => {
                        handlePrint();
                        dispatch(setPrintBtn(true));
                      }}
                      disabled={Printbtn}
                      style={{ cursor: Printbtn ? 'not-allowed' : 'pointer', opacity: Printbtn ? 0.75 : 1 }}
                    >
                      <div className="svgButtonContainer d-flex-row">
                        <FaPrint className="bill-button-svg" size={20} />
                      </div>
                      <span className="bill-button-text">Print</span>
                    </button>

                    <div className="d-flex flex-column">
                      <button
                        type="button"
                        className="whatsapp-button-group btn btn-success buttonBill save d-flex-row"
                        onClick={() => {
                          generatePDF();
                          dispatch(setWhatsappBtn(true));
                          setShowgeneratetext(true);
                        }}
                        disabled={whatsappbtn}
                        style={{ cursor: whatsappbtn ? 'not-allowed' : 'pointer', opacity: whatsappbtn ? 0.75 : 1 }}
                      >
                        <div className="svgButtonContainer d-flex-row">
                          <FaWhatsapp className="bill-button-svg" size={23} />
                        </div>
                        <span className="bill-button-text">Whatsapp</span>
                      </button>
                    </div>
                  </div>
                </div>

                {/* invoice pdf view start  */}
                <div>
                  <div
                    className="d-flex justify-content-center align-items-center "
                    ref={componentRef}
                    id="rep1"
                    style={{
                      width: "210mm",
                      minHeight: "auto",
                      padding: "20px",
                      backgroundColor: "white",
                      boxSizing: "border-box",
                      visibility: "hidden",
                      position: "absolute",
                      // "@media print": {
                      //   visibility: "visible",
                      //   position: "relative",
                      //   left: "0",
                      // },
                    }}
                  >
                    <div
                      className="receipt"
                      style={{
                        width: "100%",
                        fontFamily: "'Helvetica Neue', Arial, sans-serif",
                        color: "#1f2937",
                        fontSize: "12px",
                        lineHeight: 1.35,
                      }}
                    >
                      {/* Header */}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          borderBottom: "1.5px solid #111827",
                          paddingTop: "6px",        // ✅ adds space above INVOICE
                          paddingBottom: "8px",
                          marginBottom: "10px",
                        }}
                      >
                        <img
                          src={`${baseurl}${image_url_logo}`}
                          alt="company_logo"
                          style={{ maxHeight: "44px", objectFit: "contain" }}
                        />
                        <div style={{ textAlign: "right" }}>
                          <div style={{ fontSize: "16px", fontWeight: 700, letterSpacing: "0.5px", color: "#111827" }}>
                            INVOICE
                          </div>
                          <div style={{ color: "#6b7280", fontSize: "11px" }}>{Invoice_fullno}</div>
                          <div style={{ color: "#6b7280", fontSize: "11px" }}>{currenttodaydate}</div>
                        </div>
                      </div>

                      {/* Bill-to (single line) */}
                      <div style={{ marginBottom: "10px", fontSize: "12px" }}>
                        <span style={{ color: "#9ca3af", textTransform: "uppercase", fontSize: "10px", letterSpacing: "0.5px" }}>
                          Billed To:{" "}
                        </span>
                        <span style={{ fontWeight: 600 }}>{contact_name || defaultPosContact?.name || ""}</span>
                        <span style={{ color: "#6b7280" }}> · {contact_number || defaultPosContact?.mobile || ""}</span>
                      </div>

                      {/* Line items */}
                      <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: "10px" }}>
                        <thead>
                          <tr style={{ backgroundColor: "#111827", color: "#ffffff" }}>
                            <th style={{ textAlign: "left", padding: "5px 8px", fontSize: "10px", textTransform: "uppercase", letterSpacing: "0.4px", fontWeight: 600 }}>
                              Item
                            </th>
                            <th style={{ textAlign: "center", padding: "5px 8px", fontSize: "10px", textTransform: "uppercase", letterSpacing: "0.4px", fontWeight: 600, width: "60px" }}>
                              Qty
                            </th>
                            <th style={{ textAlign: "right", padding: "5px 8px", fontSize: "10px", textTransform: "uppercase", letterSpacing: "0.4px", fontWeight: 600, width: "100px" }}>
                              Amount
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {cart?.length > 0 &&
                            cart.map((item, idx) => (
                              <tr key={item.product_id} style={{ backgroundColor: idx % 2 === 0 ? "#ffffff" : "#f9fafb" }}>
                                <td style={{ padding: "4px 8px", borderBottom: "1px solid #f0f0f0" }}>{item.name}</td>
                                <td style={{ padding: "4px 8px", textAlign: "center", borderBottom: "1px solid #f0f0f0" }}>{item.quantity}</td>
                                <td style={{ padding: "4px 8px", textAlign: "right", borderBottom: "1px solid #f0f0f0" }}>
                                  <span style={{ color: "#9ca3af", fontSize: "10px" }}>INR </span>
                                  {item?.subT?.toFixed(2)}
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>

                      {/* Totals */}
                      <div style={{ display: "flex", justifyContent: "flex-end" }}>
                        <table style={{ width: "240px", borderCollapse: "collapse", fontSize: "12px" }}>
                          <tbody>
                            <tr>
                              <td style={{ padding: "3px 0", color: "#6b7280" }}>Gross Amount</td>
                              <td style={{ padding: "3px 0", textAlign: "right" }}>
                                <span style={{ color: "#9ca3af", fontSize: "10px" }}>INR </span>
                                {billSummary?.actualTotalPrice?.toFixed(2)}
                              </td>
                            </tr>
                            <tr>
                              <td style={{ padding: "3px 0", color: "#6b7280" }}>Discount</td>
                              <td style={{ padding: "3px 0", textAlign: "right", color: "#c0392b" }}>
                                − <span style={{ color: "#9ca3af", fontSize: "10px" }}>INR </span>
                                {billSummary?.totalDiscount?.toFixed(2)}
                              </td>
                            </tr>
                            <tr>
                              <td style={{ padding: "3px 0", color: "#6b7280" }}>Taxes</td>
                              <td style={{ padding: "3px 0", textAlign: "right" }}>
                                + <span style={{ color: "#9ca3af", fontSize: "10px" }}>INR </span>
                                {billSummary?.totalTaxes?.toFixed(2)}
                              </td>
                            </tr>
                            {(parseFloat(adjustmentValue) || 0) > 0 && (
                              <tr>
                                <td style={{ padding: "3px 0", color: "#6b7280" }}>
                                  Adjustment ({adjustmentType === "add" ? "Add" : "Deduct"})
                                </td>
                                <td style={{ padding: "3px 0", textAlign: "right" }}>
                                  {adjustmentType === "add" ? "+ " : "− "}
                                  <span style={{ color: "#9ca3af", fontSize: "10px" }}>INR </span>
                                  {(parseFloat(adjustmentValue) || 0).toFixed(2)}
                                </td>
                              </tr>
                            )}
                            <tr>
                              <td style={{ padding: "6px 0 0", borderTop: "1.5px solid #111827", fontWeight: 700, fontSize: "13px" }}>
                                Total Payable
                              </td>
                              <td style={{ padding: "6px 0 0", borderTop: "1.5px solid #111827", textAlign: "right", fontWeight: 700, fontSize: "13px", color: "#15803d" }}>
                                <span style={{ color: "#9ca3af", fontSize: "10px" }}>INR </span>
                                {billSummary?.overallTotal?.toFixed(2)}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      {/* Footer */}
                      <div style={{ marginTop: "14px", paddingTop: "8px", borderTop: "1px solid #e5e7eb", textAlign: "center", color: "#9ca3af", fontSize: "11px" }}>
                        Thank you for your business!
                      </div>
                    </div>
                  </div>
                </div>
                {/* invoice pdf  view end  */}

                {/* Contact name  */}
                <Modal
                  isOpen={contactmodal}
                  toggle={togglecontact}
                  size="lg"
                  backdrop="static"
                  keyboard={false}
                >
                  <ModalHeader toggle={togglecontact}>Contact name</ModalHeader>
                  <Form onSubmit={handleSubmit(handleSubmitContact)}>
                    <ModalBody className="grid-showcase">
                      <Container fluid={true} className="bd-example-row">
                        <Row className="mb-3">
                          <Col xs={4} md={4}>
                            <Form.Group>
                              <Form.Label>
                                <b>Name</b>
                              </Form.Label>
                              <Form.Control
                                type="text"
                                placeholder="Enter Name"
                                id="name"
                                name="name"
                                {...register("name", {
                                  required: true,
                                  maxLength: 30,
                                })}
                                onKeyDown={(e) => {
                                  if (/\d/.test(e.key)) {
                                    e.preventDefault();
                                  }
                                }}
                                required
                              />
                            </Form.Group>
                          </Col>
                          <Col xs={4} md={4}>
                            <Form.Group>
                              <Form.Label>
                                <b>Mobile No</b>
                              </Form.Label>
                              <Form.Control
                                type="tel"
                                placeholder="Enter Mobile Number"
                                id="mobile"
                                name="mobile"
                                {...register("mobile", {
                                  required: "Mobile number is required",
                                  pattern: {
                                    value: /^[0-9]{10}$/,
                                    message:
                                      "Enter a valid 10-digit mobile number",
                                  },
                                })}
                                minLength={10}
                                maxLength={10}
                                required
                              />
                            </Form.Group>
                          </Col>
                          <Col xs={4} md={4}>
                            <Form.Group>
                              <Form.Label>
                                <b>Email</b>
                              </Form.Label>
                              <Form.Control
                                type="email"
                                placeholder="Enter email"
                                name="email"
                                {...register("email")}
                                pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}"
                                title="Please enter a valid email address"
                              />
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col xs={6} md={6}>
                            <Form.Group>
                              <Form.Label>
                                <b>Address Line 1</b>
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="address1"
                                {...register("address1")}
                                required
                              />
                            </Form.Group>
                          </Col>
                          <Col xs={6} md={6}>
                            <Form.Group>
                              <Form.Label>
                                <b>Address Line 2</b>
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="address2"
                                {...register("address2")}
                              />
                            </Form.Group>
                          </Col>
                        </Row>

                        <Row className="mb-3">
                          <Col xs={3} md={3}>
                            <Form.Group>
                              <Form.Label>
                                <b>Address Type</b>
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="address_type"
                                {...register("address_type")}
                                onKeyDown={(e) => {
                                  if (/\d/.test(e.key)) {
                                    e.preventDefault();
                                  }
                                }}
                              />
                            </Form.Group>
                          </Col>
                          <Col xs={3} md={3}>
                            <Form.Group>
                              <Form.Label>
                                <b>Area</b>
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="area"
                                {...register("area")}
                                onKeyDown={(e) => {
                                  if (/\d/.test(e.key)) {
                                    e.preventDefault();
                                  }
                                }}
                              />
                            </Form.Group>
                          </Col>
                          <Col xs={3} md={3}>
                            <Form.Group>
                              <Form.Label>
                                <b>City</b>
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="city"
                                {...register("city")}
                                onKeyDown={(e) => {
                                  if (/\d/.test(e.key)) {
                                    e.preventDefault();
                                  }
                                }}
                              />
                            </Form.Group>
                          </Col>
                          <Col xs={3} md={3}>
                            <Form.Group>
                              <Form.Label>
                                <b>Pincode</b>
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="zipcode"
                                {...register("zipcode")}
                                minLength={6}
                                maxLength={6}
                                onKeyDown={(e) => {
                                  if (
                                    !/[0-9]/.test(e.key) &&
                                    e.key != "Backspace"
                                  ) {
                                    e.preventDefault();
                                  }
                                  if (
                                    e.target.value.length >= 6 &&
                                    e.key != "Backspace"
                                  ) {
                                    e.preventDefault();
                                  }
                                }}
                                required
                              />
                            </Form.Group>
                          </Col>
                        </Row>

                        <Row className="mb-3">
                          <Col xs={6} md={6}>
                            <Form.Group controlId="sel_country">
                              <Form.Label>
                                <b>Country</b>
                              </Form.Label>
                              <Form.Select
                                name="country"
                                {...register("country", { required: true })}
                                onChange={(e) => {
                                  changestate(e, 0);
                                }}
                              >
                                <option value=""> -- Select Country -- </option>
                                {country.map((cntry) => (
                                  <option
                                    key={cntry.Country.country_code}
                                    value={cntry.Country.country_name}
                                  >
                                    {cntry.Country.country_name}
                                  </option>
                                ))}
                              </Form.Select>
                              <Form.Control.Feedback type="invalid">
                                Please select a country.
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col xs={6} md={6}>
                            <Form.Group>
                              <Form.Label>
                                <b>State</b>
                              </Form.Label>
                              <Form.Select
                                name="state"
                                {...register("state", { required: true })}
                                onChange={(e) => {
                                  setAddContact({
                                    ...addcontact,
                                    state: e.target.value,
                                  });
                                }}
                              >
                                <option value=""> -- Select State -- </option>
                                {State
                                  ? [
                                    State.map((S) => (
                                      <option
                                        key={`state_${S.State.state_name}`}
                                        value={S.State.state_name}
                                      >
                                        {S.State.state_name}
                                      </option>
                                    )),
                                  ]
                                  : ""}
                              </Form.Select>
                              <Form.Control.Feedback type="invalid">
                                Please select a state.
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                        </Row>
                      </Container>
                    </ModalBody>
                    <ModalFooter>
                      <Btn
                        attrBtn={{ color: "secondary", onClick: togglecontact }}
                      >
                        Close
                      </Btn>
                      {/* <Btn
                        attrBtn={{ color: "primary", disabled: contactbtn }}
                        type="submit"
                        className="searchbtn"
                      >
                        Save Changes
                      </Btn> */}
                      <Button  type="submit" className="searchbtn" disabled={contactbtn}>
                        Save Changes
                      </Button>
                    </ModalFooter>
                  </Form>
                </Modal>

                {/* Billing address  */}
                <Modal
                  isOpen={billingmodal}
                  toggle={togglebilling}
                  size="lg"
                  backdrop="static"
                  keyboard={false}
                >
                  <ModalHeader toggle={togglebilling}>
                    Billing Address
                  </ModalHeader>
                  <Form onSubmit={(e) => handleSubmitAddressBilling(e)}>
                    {" "}
                    <ModalBody className="grid-showcase">
                      <Container fluid={true} className="bd-example-row">
                        <Row className="mb-3">
                          <Col xs={6}>
                            <Form.Group>
                              <Form.Label>
                                <b>Address Type</b>
                              </Form.Label>
                              <Form.Control
                                type="text"
                                id="txt_add_type_new_billing"
                                name="txt_add_type_new_billing"
                                value={nickname_billing}
                                onChange={handleChangeFieldbilling}
                                required
                              />
                            </Form.Group>
                          </Col>
                        </Row>

                        <Row className="mb-3">
                          <Col xs={6} md={6}>
                            <Form.Group>
                              <Form.Label>
                                <b>Address Line 1</b>
                              </Form.Label>
                              <Form.Control
                                type="text"
                                id="txt_add_new1_billing"
                                name="txt_add_new1_billing"
                                value={address1_billing}
                                onChange={handleChangeFieldbilling}
                                // onKeyDown={(e) => {
                                //   if (/\d/.test(e.key)) {
                                //     e.preventDefault();
                                //   }
                                // }}
                                required
                              />
                            </Form.Group>
                          </Col>
                          <Col xs={6} md={6}>
                            <Form.Group>
                              <Form.Label>
                                <b>Addrss Line 2</b>
                              </Form.Label>
                              <Form.Control
                                type="text"
                                id="txt_add_new2_billing"
                                name="txt_add_new2_billing"
                                value={address2_billing}
                                onChange={handleChangeFieldbilling}
                              // onKeyDown={(e) => {
                              //   if (/\d/.test(e.key)) {
                              //     e.preventDefault();
                              //   }
                              // }}
                              // required
                              />
                            </Form.Group>
                          </Col>
                        </Row>

                        <Row className="mb-3">
                          <Col xs={4} md={4}>
                            <Form.Group>
                              <Form.Label><b>Area</b></Form.Label>
                              <Form.Control
                                type="text"
                                id="txt_area_new_billing"
                                name="txt_area_new_billing"
                                value={area_billing}
                                onChange={handleChangeFieldbilling}
                                required
                              />
                            </Form.Group>
                          </Col>
                          <Col xs={4} md={4}>
                            <Form.Group>
                              <Form.Label><b>City</b></Form.Label>
                              <Form.Control
                                type="text"
                                id="txt_city_new_billing"
                                name="txt_city_new_billing"
                                value={city_billing}
                                onChange={handleChangeFieldbilling}
                                required
                              />
                            </Form.Group>
                          </Col>
                          <Col xs={4} md={4}>
                            <Form.Group>
                              <Form.Label><b>Pincode</b></Form.Label>
                              <Form.Control
                                type="text"
                                inputMode="numeric"
                                pattern="[0-9]{6}"
                                maxLength={6}
                                id="txt_zipcode_new_billing"
                                name="txt_zipcode_new_billing"
                                value={zipcode_billing}
                                onChange={handleChangeFieldbilling}
                                required
                              />
                            </Form.Group>
                          </Col>
                        </Row>

                        <Row className="mb-3">
                          <Col xs={6} md={6}>
                            <Form.Group controlId="sel_country_new">
                              <Form.Label>
                                <b>Country</b>
                              </Form.Label>
                              <Form.Select
                                id="sel_country_new_billing"
                                name="sel_country_new_billing"
                                onChange={(e) => {
                                  changestate(e, 0);
                                }}
                                value={selcountry_billing}
                                required
                              >
                                <option value=""> -- Select Country -- </option>
                                {country
                                  ? [
                                    country.map((C) => (
                                      <option
                                        key={`country_${C.Country.country_code}`}
                                        value={C.Country.country_name}
                                      >
                                        {C.Country.country_name}
                                      </option>
                                    )),
                                  ]
                                  : ""}
                              </Form.Select>
                              <Form.Control.Feedback type="invalid">
                                Please select a country.
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col xs={6} md={6}>
                            <Form.Group controlId="sel_state_new">
                              <Form.Label>
                                <b>State</b>
                              </Form.Label>
                              <Form.Select
                                id="sel_state_new_billing"
                                name="sel_state_new_billing"
                                value={selstate_billing}
                                onChange={handleChangeFieldbilling}
                                required
                              >
                                <option value=""> -- Select State -- </option>
                                {State
                                  ? [
                                    State.map((S) => (
                                      <option
                                        key={`state_${S.State.state_name}`}
                                        value={S.State.state_name}
                                      >
                                        {S.State.state_name}
                                      </option>
                                    )),
                                  ]
                                  : ""}
                              </Form.Select>
                              <Form.Control.Feedback type="invalid">
                                Please select a state.
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                        </Row>
                      </Container>
                    </ModalBody>
                    <ModalFooter>
                      <Btn
                        attrBtn={{ color: "secondary", onClick: togglebilling }}
                      >
                        Close
                      </Btn>
                      <Button  type="submit" className="searchbtn">
                        SaveChanges
                      </Button>
                    </ModalFooter>
                  </Form>
                </Modal>

                {/* Shipping address  */}
                <Modal
                  isOpen={shippingmodal}
                  toggle={toggleshipping}
                  size="lg"
                  backdrop="static"
                  keyboard={false}
                >
                  <ModalHeader toggle={toggleshipping}>
                    Shipping Address
                  </ModalHeader>
                  <Form onSubmit={(e) => handleSubmitAddressShipping(e)}>
                    <ModalBody className="grid-showcase">
                      <Container fluid={true} className="bd-example-row">

                        {/* Address Type */}
                        <Row className="mb-3">
                          <Col xs={6}>
                            <Form.Group>
                              <Form.Label><b>Address Type</b></Form.Label>
                              <Form.Control
                                type="text"
                                id="txt_add_type_new_shipping"
                                name="txt_add_type_new_shipping"
                                value={nickname_shipping}
                                onChange={handleChangeFieldShipping}
                                required
                              />
                            </Form.Group>
                          </Col>
                        </Row>

                        {/* Address Line 1 & 2 */}
                        <Row className="mb-3">
                          <Col xs={6} md={6}>
                            <Form.Group>
                              <Form.Label><b>Address Line 1</b></Form.Label>
                              <Form.Control
                                type="text"
                                id="txt_add_new1_shipping"
                                name="txt_add_new1_shipping"
                                value={address1_shipping}
                                onChange={handleChangeFieldShipping}
                                required
                              />
                            </Form.Group>
                          </Col>
                          <Col xs={6} md={6}>
                            <Form.Group>
                              <Form.Label><b>Address Line 2</b></Form.Label>
                              <Form.Control
                                type="text"
                                id="txt_add_new2_shipping"
                                name="txt_add_new2_shipping"
                                value={address2_shipping}
                                onChange={handleChangeFieldShipping}
                              />
                            </Form.Group>
                          </Col>
                        </Row>

                        {/* Area / City / Pincode in one row */}
                        <Row className="mb-3">
                          <Col xs={4} md={4}>
                            <Form.Group>
                              <Form.Label><b>Area</b></Form.Label>
                              <Form.Control
                                type="text"
                                id="txt_area_new_shipping"
                                name="txt_area_new_shipping"
                                value={area_shipping}
                                onChange={handleChangeFieldShipping}
                                onKeyDown={(e) => {
                                  if (/\d/.test(e.key)) e.preventDefault();
                                }}
                                required
                              />
                            </Form.Group>
                          </Col>
                          <Col xs={4} md={4}>
                            <Form.Group>
                              <Form.Label><b>City</b></Form.Label>
                              <Form.Control
                                type="text"
                                id="txt_city_new_shipping"
                                name="txt_city_new_shipping"
                                value={city_shipping}
                                onChange={handleChangeFieldShipping}
                                onKeyDown={(e) => {
                                  if (/\d/.test(e.key)) e.preventDefault();
                                }}
                                required
                              />
                            </Form.Group>
                          </Col>
                          <Col xs={4} md={4}>
                            <Form.Group>
                              <Form.Label><b>Pincode</b></Form.Label>
                              <Form.Control
                                type="text"
                                inputMode="numeric"
                                pattern="[0-9]{6}"
                                maxLength={6}
                                id="txt_zipcode_new_shipping"
                                name="txt_zipcode_new_shipping"
                                value={zipcode_shipping}
                                onChange={handleChangeFieldShipping}
                                required
                              />
                            </Form.Group>
                          </Col>
                        </Row>

                        {/* Country / State */}
                        <Row className="mb-3">
                          <Col xs={6} md={6}>
                            <Form.Group controlId="sel_country">
                              <Form.Label><b>Country</b></Form.Label>
                              <Form.Select
                                id="sel_country_shipping"
                                name="sel_country_shipping"
                                onChange={(e) => {
                                  changestate(e, 0);
                                }}
                                value={selcountry_shipping}
                                required
                              >
                                <option value=""> -- Select Country -- </option>
                                {country
                                  ? [
                                    country.map((C) => (
                                      <option
                                        key={`country_${C.Country.country_code}`}
                                        value={C.Country.country_name}
                                      >
                                        {C.Country.country_name}
                                      </option>
                                    )),
                                  ]
                                  : ""}
                              </Form.Select>
                              <Form.Control.Feedback type="invalid">
                                Please select a country.
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col xs={6} md={6}>
                            <Form.Group controlId="sel_state_new">
                              <Form.Label><b>State</b></Form.Label>
                              <Form.Select
                                id="sel_state_new_shipping"
                                name="sel_state_new_shipping"
                                value={selstate_shipping}
                                onChange={handleChangeFieldShipping}
                                required
                              >
                                <option value=""> -- Select State -- </option>
                                {State
                                  ? [
                                    State.map((S) => (
                                      <option
                                        key={`state_${S.State.state_name}`}
                                        value={S.State.state_name}
                                      >
                                        {S.State.state_name}
                                      </option>
                                    )),
                                  ]
                                  : ""}
                              </Form.Select>
                              <Form.Control.Feedback type="invalid">
                                Please select a state.
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                        </Row>

                      </Container>
                    </ModalBody>
                    <ModalFooter>
                      <Btn
                        attrBtn={{
                          color: "secondary",
                          onClick: toggleshipping,
                        }}
                      >
                        Close
                      </Btn>
                      <Button type="submit" className="searchbtn">
                        SaveChanges
                      </Button>
                    </ModalFooter>
                  </Form>
                </Modal>

                {/* modal attribute */}
                <Modal
                  isOpen={showattrmodal}
                  toggle={toggleattributemodal}
                  size="xl"
                  backdrop="static"
                  keyboard={false}
                  className="attr-modal"
                >
                  <ModalHeader
                    toggle={() => {
                      setShowattrmodal(!showattrmodal);
                      setProductselectid("");
                      setSelectedProduct(null);
                    }}
                    className="Modal-addressheader"
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                        width: "100%",
                      }}
                    >
                      <span
                        style={{
                          fontSize: "16px",
                          fontWeight: "600",
                          lineHeight: "1.3",
                          wordBreak: "break-word",
                        }}
                      >
                        {AttrProductname}
                      </span>
                      {productImage && (
                        <img
                          src={productImage}
                          alt={AttrProductname}
                          style={{
                            width: "40px",
                            height: "40px",
                            objectFit: "cover",
                            borderRadius: "8px",
                            flexShrink: 0,
                          }}
                        />
                      )}
                    </div>
                  </ModalHeader>
                  <Form onSubmit={handleSubmit(onsubmit)}>
                    <ModalBody style={{ padding: "12px" }}>
                      {pricelist_array.length > 0 ? (
                        <div
                          className="attr-table-scroll"
                          style={{
                            width: "100%",
                            maxHeight: "65vh",
                            overflowX: "auto",
                            overflowY: "auto",
                            WebkitOverflowScrolling: "touch",
                          }}
                        >
                          <Table
                            striped
                            bordered
                            hover
                            className="mb-0"
                            style={{ minWidth: "max-content", whiteSpace: "nowrap" }}
                          >
                            <thead
                              style={{
                                position: "sticky",
                                top: 0,
                                zIndex: 2,
                                background: "#fff",
                              }}
                            >
                              <tr>
                                <th
                                  style={{
                                    position: "sticky",
                                    left: 0,
                                    zIndex: 3,
                                    background: "#fff",
                                  }}
                                >
                                  #
                                </th>
                                <th>Price List</th>
                                <th>Price</th>
                                {visibleAttrKeys.map((key) => (
                                  <th key={key}>{attr_label[key]?.Label}</th>
                                ))}
                              </tr>
                            </thead>
                            <tbody>
                              {pricelist_array.map((item, index) => (
                                <tr key={index}>
                                  <td
                                    style={{
                                      cursor: "pointer",
                                      position: "sticky",
                                      left: 0,
                                      zIndex: 1,
                                      background: "#fff",
                                      textAlign: "center",
                                    }}
                                    onClick={() => Saveattributejson(index)}
                                  >
                                    <IoIosAddCircle size={25} />
                                  </td>
                                  <td>{item.pricelist_name || "---"}</td>
                                  <td>{item.price}</td>
                                  {visibleAttrKeys.map((key) => {
                                    const attrId = attr_label[key]?.ID;
                                    const attr = item.attr_arr?.find(
                                      (a) => String(a.ID) === String(attrId)
                                    );
                                    return (
                                      <td key={key} className="text-center">
                                        {attr && attr.Value ? attr.Value : "---"}
                                      </td>
                                    );
                                  })}
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        </div>
                      ) : (
                        <div>No attribute found</div>
                      )}
                    </ModalBody>
                    <ModalFooter>
                      <Button
                        variant="secondary"
                        size="sm"
                        onClick={() => {
                          setShowattrmodal(!showattrmodal);
                          setProductselectid("");
                          setSelectedProduct(null);
                          setJson({});
                          setJsonName({});
                        }}
                      >
                        Close
                      </Button>
                    </ModalFooter>
                  </Form>
                </Modal>

                {/* 8. RENDER — place next to the existing pricelist attribute <Modal> */}
                <AttributeMasterModal
                  isOpen={showAttrMasterModal}
                  toggle={toggleAttrMasterModal}
                  productName={AttrProductname}
                  productImage={productImage}
                  attrMasterPre={attrMasterPre}
                  attrMasterArr={attrMasterArr}
                  onSelectRow={handleAttrMasterRowSelect}
                />
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default Dashboardpos;